(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@labkey/api"] = factory();
	else
		root["@labkey/api"] = factory();
})(self, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 72:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   buildURL: () => (/* binding */ buildURL),
/* harmony export */   decodePath: () => (/* binding */ decodePath),
/* harmony export */   encodePath: () => (/* binding */ encodePath),
/* harmony export */   getAction: () => (/* binding */ getAction),
/* harmony export */   getBaseURL: () => (/* binding */ getBaseURL),
/* harmony export */   getContainer: () => (/* binding */ getContainer),
/* harmony export */   getContainerName: () => (/* binding */ getContainerName),
/* harmony export */   getContextPath: () => (/* binding */ getContextPath),
/* harmony export */   getController: () => (/* binding */ getController),
/* harmony export */   getParameter: () => (/* binding */ getParameter),
/* harmony export */   getParameterArray: () => (/* binding */ getParameterArray),
/* harmony export */   getParameters: () => (/* binding */ getParameters),
/* harmony export */   getPathFromLocation: () => (/* binding */ getPathFromLocation),
/* harmony export */   getReturnUrl: () => (/* binding */ getReturnUrl),
/* harmony export */   queryString: () => (/* binding */ queryString)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(218);
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(198);


function buildParameterMap(paramString) {
    const { postParameters } = (0,_constants__WEBPACK_IMPORTED_MODULE_0__/* .getServerContext */ .$K)();
    if (!paramString && postParameters) {
        return postParameters;
    }
    if (!paramString) {
        paramString = (0,_constants__WEBPACK_IMPORTED_MODULE_0__/* .getLocation */ .g$)().search;
    }
    if (paramString.charAt(0) == '?') {
        paramString = paramString.substring(1, paramString.length);
    }
    const paramArray = paramString.split('&');
    const parameters = {};
    for (let i = 0; i < paramArray.length; i++) {
        const nameValue = paramArray[i].split('=', 2);
        if (nameValue.length == 1 && nameValue[0] != '') {
            nameValue[1] = '';
        }
        if (nameValue.length == 2) {
            const name = decodeURIComponent(nameValue[0]);
            if (undefined == parameters[name]) {
                parameters[name] = decodeURIComponent(nameValue[1]);
            }
            else {
                const curValue = parameters[name];
                if ((0,_Utils__WEBPACK_IMPORTED_MODULE_1__.isArray)(curValue)) {
                    curValue.push(decodeURIComponent(nameValue[1]));
                }
                else {
                    parameters[name] = [curValue, decodeURIComponent(nameValue[1])];
                }
            }
        }
    }
    return parameters;
}
function buildURL(controller, action, containerPath, parameters) {
    if (!containerPath) {
        containerPath = getContainer();
    }
    containerPath = encodePath(containerPath);
    if (containerPath.charAt(0) != '/') {
        containerPath = '/' + containerPath;
    }
    if (containerPath.charAt(containerPath.length - 1) != '/') {
        containerPath = containerPath + '/';
    }
    if (action.indexOf('.') == -1) {
        action += '.view';
    }
    const query = queryString(parameters);
    let newURL;
    const { contextPath, experimental } = (0,_constants__WEBPACK_IMPORTED_MODULE_0__/* .getServerContext */ .$K)();
    if (experimental && experimental.containerRelativeURL) {
        newURL = contextPath + containerPath + controller + '-' + action;
    }
    else {
        newURL = contextPath + '/' + controller + containerPath + action;
    }
    if (query) {
        newURL += '?' + query;
    }
    return newURL;
}
function decodePath(encodedPath) {
    return codePath(encodedPath, decodeURIComponent);
}
function encodePath(decodedPath) {
    return codePath(decodedPath, encodeURIComponent);
}
function getAction() {
    return getPathFromLocation().action;
}
function getBaseURL(noContextPath) {
    const location = (0,_constants__WEBPACK_IMPORTED_MODULE_0__/* .getLocation */ .g$)();
    return location.protocol + '//' + location.host + (noContextPath ? '' : getContextPath() + '/');
}
function getContainer() {
    const { container } = (0,_constants__WEBPACK_IMPORTED_MODULE_0__/* .getServerContext */ .$K)();
    if (container && container.path) {
        return container.path;
    }
    return getPathFromLocation().containerPath;
}
function getContainerName() {
    const containerPath = getContainer();
    return containerPath.substring(containerPath.lastIndexOf('/') + 1);
}
function getContextPath() {
    return (0,_constants__WEBPACK_IMPORTED_MODULE_0__/* .getServerContext */ .$K)().contextPath;
}
function getController() {
    return getPathFromLocation().controller;
}
function getParameter(parameterName) {
    const val = buildParameterMap()[parameterName];
    return val && (0,_Utils__WEBPACK_IMPORTED_MODULE_1__.isArray)(val) && val.length > 0 ? val[0] : val;
}
function getParameterArray(parameterName) {
    const val = buildParameterMap()[parameterName];
    return val && !(0,_Utils__WEBPACK_IMPORTED_MODULE_1__.isArray)(val) ? [val] : val;
}
function getParameters(url) {
    if (!url) {
        return buildParameterMap(url);
    }
    let paramString = url;
    if (url.indexOf('?') != -1) {
        paramString = url.substring(url.indexOf('?') + 1, url.length);
    }
    return buildParameterMap(paramString);
}
function fullyDecodeURIPath(path) {
    return decodeURI(path)
        .replace(/%2C/g, ',')
        .replace(/%2B/g, '+')
        .replace(/%3B/g, ';')
        .replace(/%40/g, '@')
        .replace(/%26/g, '&')
        .replace(/%3D/g, '=')
        .replace(/%24/g, '$')
        .replace(/%23/g, '#');
}
function getPathFromLocation(pathname, contextPath) {
    const ctxPath = contextPath !== null && contextPath !== void 0 ? contextPath : getContextPath();
    const start = ctxPath ? ctxPath.length : 0;
    let path = pathname !== null && pathname !== void 0 ? pathname : (0,_constants__WEBPACK_IMPORTED_MODULE_0__/* .getLocation */ .g$)().pathname;
    const qMarkIdx = path.indexOf('?');
    if (qMarkIdx > -1) {
        path = path.substring(0, qMarkIdx);
    }
    const end = path.lastIndexOf('/');
    let action = path.substring(end + 1);
    path = path.substring(start, end);
    let controller;
    const dash = action.lastIndexOf('-');
    if (dash > 0) {
        controller = action.substring(0, dash);
        action = action.substring(dash + 1);
    }
    else {
        const slash = path.indexOf('/', 1);
        if (slash < 0) {
            controller = path.substring(1);
        }
        else {
            controller = path.substring(1, slash);
        }
        path = path.substring(slash);
    }
    const dot = action.indexOf('.');
    if (dot > 0) {
        action = action.substring(0, dot);
    }
    return {
        action: decodeURIComponent(action),
        containerPath: fullyDecodeURIPath(path),
        contextPath: decodeURIComponent(ctxPath),
        controller: decodeURIComponent(controller),
    };
}
function getReturnUrl() {
    return getParameter('returnUrl');
}
function queryString(parameters) {
    if (!parameters) {
        return '';
    }
    let query = '', and = '', pval, parameter, aval;
    for (parameter in parameters) {
        if (parameters.hasOwnProperty(parameter)) {
            pval = parameters[parameter];
            if (pval === null || pval === undefined) {
                pval = '';
            }
            else if ((0,_Utils__WEBPACK_IMPORTED_MODULE_1__.isFunction)(pval)) {
                continue;
            }
            if ((0,_Utils__WEBPACK_IMPORTED_MODULE_1__.isArray)(pval)) {
                for (let idx = 0; idx < pval.length; ++idx) {
                    aval = pval[idx];
                    query += and + encodeURIComponent(parameter) + '=' + encodeURIComponent(pval[idx]);
                    and = '&';
                }
            }
            else {
                query += and + encodeURIComponent(parameter) + '=' + encodeURIComponent(pval);
                and = '&';
            }
        }
    }
    return query;
}
function codePath(path, method) {
    const a = path.split('/');
    for (let i = 0; i < a.length; i++) {
        a[i] = method(a[i]);
    }
    return a.join('/');
}


/***/ }),

/***/ 932:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   W: () => (/* binding */ FieldKey)
/* harmony export */ });
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(198);
/* harmony import */ var _QueryKey__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(300);


class FieldKey extends _QueryKey__WEBPACK_IMPORTED_MODULE_1__/* .QueryKey */ .k {
    static fromParts(parts) {
        let ret = null;
        for (let i = 0; i < arguments.length; i++) {
            const arg = arguments[i];
            if ((0,_Utils__WEBPACK_IMPORTED_MODULE_0__.isString)(arg)) {
                ret = new FieldKey(ret, arg);
            }
            else if (arg && arg.length) {
                for (let j = 0; j < arg.length; j++) {
                    ret = new FieldKey(ret, arg[j]);
                }
            }
            else {
                throw 'Illegal argument to fromParts: ' + arg;
            }
        }
        return ret;
    }
    static fromString(s) {
        let ret = null;
        const r = s.split('/');
        for (let i = 0; i < r.length; i++) {
            ret = new FieldKey(ret, _QueryKey__WEBPACK_IMPORTED_MODULE_1__/* .QueryKey */ .k.decodePart(r[i]));
        }
        return ret;
    }
    toString() {
        return super.toString('/');
    }
}


/***/ }),

/***/ 300:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   k: () => (/* binding */ QueryKey)
/* harmony export */ });
class QueryKey {
    static decodePart(s) {
        return s
            .replace(/\$P/g, '.')
            .replace(/\$C/g, ',')
            .replace(/\$T/g, '~')
            .replace(/\$B/g, '}')
            .replace(/\$A/g, '&')
            .replace(/\$S/g, '/')
            .replace(/\$D/g, '$');
    }
    static encodePart(s) {
        return s
            .replace(/\$/g, '$D')
            .replace(/\//g, '$S')
            .replace(/\&/g, '$A')
            .replace(/\}/g, '$B')
            .replace(/\~/g, '$T')
            .replace(/\,/g, '$C')
            .replace(/\./g, '$P');
    }
    static needsQuotes(s) {
        if (!s.match(/^[a-zA-Z][_\$a-zA-Z0-9]*$/))
            return true;
        if (s.match(/^(all|any|and|as|asc|avg|between|class|count|delete|desc|distinct|elements|escape|exists|false|fetch|from|full|group|having|in|indices|inner|insert|into|is|join|left|like|limit|max|min|new|not|null|or|order|outer|right|select|set|some|sum|true|union|update|user|versioned|where|case|end|else|then|when|on|both|empty|leading|member|of|trailing)$/i))
            return true;
        return false;
    }
    static quote(s) {
        return '"' + s.replace(/\"/g, '""') + '"';
    }
    constructor(parent, name) {
        this.name = name;
        this.parent = parent;
    }
    equals(other) {
        return (other != null &&
            this.constructor == other.constructor &&
            this.toString().toLowerCase() == other.toString().toLowerCase());
    }
    getName() {
        return this.name;
    }
    getParts() {
        let ret = [];
        if (this.parent) {
            ret = this.parent.getParts();
        }
        ret.push(this.name);
        return ret;
    }
    toDisplayString() {
        return this.getParts().join('.');
    }
    toJSON() {
        return this.toString();
    }
    toSQLString() {
        const encoded = [];
        const parts = this.getParts();
        for (let i = 0; i < parts.length; i++) {
            if (QueryKey.needsQuotes(parts[i])) {
                encoded.push(QueryKey.quote(parts[i]));
            }
            else {
                encoded.push(parts[i]);
            }
        }
        return encoded.join('.');
    }
    toString(divider) {
        const encoded = [];
        const parts = this.getParts();
        for (let i = 0; i < parts.length; i++) {
            encoded.push(QueryKey.encodePart(parts[i]));
        }
        return encoded.join(divider);
    }
}


/***/ }),

/***/ 13:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   z: () => (/* binding */ SchemaKey)
/* harmony export */ });
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(198);
/* harmony import */ var _QueryKey__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(300);


class SchemaKey extends _QueryKey__WEBPACK_IMPORTED_MODULE_1__/* .QueryKey */ .k {
    static fromParts(parts) {
        let ret = null;
        for (let i = 0; i < arguments.length; i++) {
            const arg = arguments[i];
            if ((0,_Utils__WEBPACK_IMPORTED_MODULE_0__.isString)(arg)) {
                ret = new SchemaKey(ret, arg);
            }
            else if (arg && arg.length) {
                for (let j = 0; j < arg.length; j++) {
                    ret = new SchemaKey(ret, arg[j]);
                }
            }
            else {
                throw 'Illegal argument to fromParts: ' + arg;
            }
        }
        return ret;
    }
    static fromString(s) {
        const r = s.split('.');
        let ret = null;
        for (let i = 0; i < r.length; i++) {
            ret = new SchemaKey(ret, _QueryKey__WEBPACK_IMPORTED_MODULE_1__/* .QueryKey */ .k.decodePart(r[i]));
        }
        return ret;
    }
    toString() {
        return super.toString('.');
    }
}


/***/ }),

/***/ 198:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   alert: () => (/* binding */ alert),
/* harmony export */   apply: () => (/* binding */ apply),
/* harmony export */   applyTranslated: () => (/* binding */ applyTranslated),
/* harmony export */   capitalize: () => (/* binding */ capitalize),
/* harmony export */   caseInsensitiveEquals: () => (/* binding */ caseInsensitiveEquals),
/* harmony export */   decode: () => (/* binding */ decode),
/* harmony export */   deleteCookie: () => (/* binding */ deleteCookie),
/* harmony export */   displayAjaxErrorResponse: () => (/* binding */ displayAjaxErrorResponse),
/* harmony export */   encode: () => (/* binding */ encode),
/* harmony export */   encodeHtml: () => (/* binding */ encodeHtml),
/* harmony export */   endsWith: () => (/* binding */ endsWith),
/* harmony export */   ensureBoxVisible: () => (/* binding */ ensureBoxVisible),
/* harmony export */   ensureRegionName: () => (/* binding */ ensureRegionName),
/* harmony export */   escapeRe: () => (/* binding */ escapeRe),
/* harmony export */   generateUUID: () => (/* binding */ generateUUID),
/* harmony export */   getCallbackWrapper: () => (/* binding */ getCallbackWrapper),
/* harmony export */   getCookie: () => (/* binding */ getCookie),
/* harmony export */   getDateAltFormats: () => (/* binding */ getDateAltFormats),
/* harmony export */   getDateTimeFormatWithMS: () => (/* binding */ getDateTimeFormatWithMS),
/* harmony export */   getFileIconUrl: () => (/* binding */ getFileIconUrl),
/* harmony export */   getMeasureAlias: () => (/* binding */ getMeasureAlias),
/* harmony export */   getMsgFromError: () => (/* binding */ getMsgFromError),
/* harmony export */   getOnFailure: () => (/* binding */ getOnFailure),
/* harmony export */   getOnSuccess: () => (/* binding */ getOnSuccess),
/* harmony export */   getSessionID: () => (/* binding */ getSessionID),
/* harmony export */   id: () => (/* binding */ id),
/* harmony export */   isArray: () => (/* binding */ isArray),
/* harmony export */   isBoolean: () => (/* binding */ isBoolean),
/* harmony export */   isDate: () => (/* binding */ isDate),
/* harmony export */   isDefined: () => (/* binding */ isDefined),
/* harmony export */   isEmptyObj: () => (/* binding */ isEmptyObj),
/* harmony export */   isFunction: () => (/* binding */ isFunction),
/* harmony export */   isNumber: () => (/* binding */ isNumber),
/* harmony export */   isObject: () => (/* binding */ isObject),
/* harmony export */   isString: () => (/* binding */ isString),
/* harmony export */   merge: () => (/* binding */ merge),
/* harmony export */   mergeIf: () => (/* binding */ mergeIf),
/* harmony export */   onError: () => (/* binding */ onError),
/* harmony export */   onReady: () => (/* binding */ onReady),
/* harmony export */   onTrue: () => (/* binding */ onTrue),
/* harmony export */   padString: () => (/* binding */ padString),
/* harmony export */   parseDateString: () => (/* binding */ parseDateString),
/* harmony export */   pluralBasic: () => (/* binding */ pluralBasic),
/* harmony export */   pluralize: () => (/* binding */ pluralize),
/* harmony export */   requiresCSS: () => (/* binding */ requiresCSS),
/* harmony export */   requiresScript: () => (/* binding */ requiresScript),
/* harmony export */   resizeToViewport: () => (/* binding */ resizeToViewport),
/* harmony export */   roundNumber: () => (/* binding */ roundNumber),
/* harmony export */   setCookie: () => (/* binding */ setCookie),
/* harmony export */   textLink: () => (/* binding */ textLink),
/* harmony export */   wafEncode: () => (/* binding */ wafEncode)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(218);
/* harmony import */ var _ActionURL__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72);


const CHARS = '0123456789abcdefghijklmnopqrstuvwxyz'.split('');
const ENUMERABLES = [
    'hasOwnProperty',
    'valueOf',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'constructor',
];
const ID_PREFIX = 'lk-gen';
let idSeed = 100;
const DATEALTFORMATS_Either = [
    'j-M-y g:i a|j-M-Y g:i a|j-M-y G:i|j-M-Y G:i|',
    'j-M-y|j-M-Y|',
    'Y-n-d H:i:s|Y-n-d|',
    'Y/n/d H:i:s|Y/n/d|',
    'j M Y G:i:s O|',
    'j M Y H:i:s|c',
].join('');
const DATEALTFORMATS_MonthDay = [
    'n/j/y g:i:s a|n/j/Y g:i:s a|n/j/y G:i:s|n/j/Y G:i:s|',
    'n-j-y g:i:s a|n-j-Y g:i:s a|n-j-y G:i:s|n-j-Y G:i:s|',
    'n/j/y g:i a|n/j/Y g:i a|n/j/y G:i|n/j/Y G:i|',
    'n-j-y g:i a|n-j-Y g:i a|n-j-y G:i|n-j-Y G:i|',
    'n/j/y|n/j/Y|',
    'n-j-y|n-j-Y|',
    DATEALTFORMATS_Either,
].join('');
const DATEALTFORMATS_DayMonth = [
    'j/n/y g:i:s a|j/n/Y g:i:s a|j/n/y G:i:s|j/n/Y G:i:s|',
    'j-n-y g:i:s a|j-n-Y g:i:s a|j-n-y G:i:s|j-n-Y G:i:s|',
    'j/n/y g:i a|j/n/Y g:i a|j/n/y G:i|j/n/Y G:i|',
    'j-n-y g:i a|j-n-Y g:i a|j-n-y G:i|j-n-Y G:i|',
    'j/n/y|j/n/Y|',
    'j-n-y|j-n-Y|',
    'j-M-y|j-M-Y|',
].join('');
const DATETIMEFORMAT_WithMS = 'Y-m-d H:i:s.u';
function _copy(o, depth) {
    if (depth == 0 || !isObject(o)) {
        return o;
    }
    const copy = {};
    for (const key in o) {
        copy[key] = _copy(o[key], depth - 1);
    }
    return copy;
}
function _merge(to, from, overwrite, depth) {
    for (const key in from) {
        if (from.hasOwnProperty(key)) {
            if (isObject(to[key]) && isObject(from[key])) {
                _merge(to[key], from[key], overwrite, depth - 1);
            }
            else if (undefined === to[key] || overwrite) {
                to[key] = _copy(from[key], depth - 1);
            }
        }
    }
}
function apply(object, config) {
    if (object && config && typeof config === 'object') {
        let i, j, k;
        for (i in config) {
            object[i] = config[i];
        }
        for (j = ENUMERABLES.length; j--;) {
            k = ENUMERABLES[j];
            if (config.hasOwnProperty(k)) {
                object[k] = config[k];
            }
        }
    }
    return object;
}
function applyTranslated(target, source, translationMap, applyOthers, applyFunctions) {
    if (undefined === target) {
        target = {};
    }
    if (undefined === applyOthers) {
        applyOthers = true;
    }
    if (undefined == applyFunctions && applyOthers) {
        applyFunctions = true;
    }
    let targetPropName;
    for (const prop in source) {
        if (source.hasOwnProperty(prop)) {
            if (prop == 'constructor' || isFunction(prop)) {
                continue;
            }
            targetPropName = translationMap[prop];
            if (targetPropName) {
                target[translationMap[prop]] = source[prop];
            }
            else if (undefined === targetPropName && applyOthers && (applyFunctions || !isFunction(source[prop]))) {
                target[prop] = source[prop];
            }
        }
    }
}
const DOMWrappers = {};
function DOMWrapper(fnName) {
    if (!fnName) {
        throw new Error('DOMWrapper must wrap a named function.');
    }
    if (DOMWrappers.hasOwnProperty(fnName)) {
        throw new Error(`DOMWrapper cannot wrap "${fnName}" more than once.`);
    }
    DOMWrappers[fnName] = function () {
        if (LABKEY &&
            LABKEY.Utils &&
            isFunction(LABKEY.Utils[fnName]) &&
            LABKEY.Utils[fnName] !== DOMWrappers[fnName]) {
            LABKEY.Utils[fnName].apply(this, arguments);
        }
        else {
            console.warn(`Utils.${fnName}: This is just a stub implementation. ` +
                'Request the DOM version of the client API, ' +
                'clientapi_dom.lib.xml, to get the concrete implementation.');
        }
    };
    return DOMWrappers[fnName];
}
const alert = DOMWrapper('alert');
function capitalize(value) {
    if (value && isString(value) && value.length > 0) {
        return value.charAt(0).toUpperCase() + value.substr(1);
    }
    return value;
}
function caseInsensitiveEquals(a, b) {
    return String(a).toLowerCase() == String(b).toLowerCase();
}
function ensureRegionName(regionName) {
    return regionName && isString(regionName) ? regionName : 'query';
}
function decode(data) {
    return JSON.parse(data + '');
}
function deleteCookie(name, pageOnly) {
    setCookie(name, '', pageOnly, -1);
}
const displayAjaxErrorResponse = DOMWrapper('displayAjaxErrorResponse');
function encode(data) {
    return JSON.stringify(data);
}
function encodeHtml(html, retainEmptyValueTypes) {
    if (html === undefined || html === null) {
        return retainEmptyValueTypes ? html : '';
    }
    return String(html)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\\/g, '&#92;');
}
function escapeRe(s) {
    return s.replace(/([-.*+?\^${}()|\[\]\/\\])/g, '\\$1');
}
function endsWith(value, ending) {
    if (!value || !ending) {
        return false;
    }
    if (value.length < ending.length) {
        return false;
    }
    return value.substring(value.length - ending.length) == ending;
}
function ensureBoxVisible() {
    console.warn('ensureBoxVisible() has been migrated to the appropriate Ext scope. Consider LABKEY.ext.Utils.ensureBoxVisible or LABKEY.ext4.Util.ensureBoxVisible');
}
function generateUUID() {
    const { uuids } = (0,_constants__WEBPACK_IMPORTED_MODULE_0__/* .getServerContext */ .$K)();
    if (uuids && uuids.length > 0) {
        return uuids.pop();
    }
    let uuid = new Array(36), rnd = 0, r;
    for (let i = 0; i < 36; i++) {
        if (i == 8 || i == 13 || i == 18 || i == 23) {
            uuid[i] = '-';
        }
        else if (i == 14) {
            uuid[i] = '4';
        }
        else {
            if (rnd <= 0x02) {
                rnd = (0x2000000 + Math.random() * 0x1000000) | 0;
            }
            r = rnd & 0xf;
            rnd = rnd >> 4;
            uuid[i] = CHARS[i == 19 ? (r & 0x3) | 0x8 : r];
        }
    }
    return uuid.join('');
}
function getCallbackWrapper(fn, scope, isErrorCallback, responseTransformer) {
    return function (response, options) {
        let json = response.responseJSON;
        if (!json) {
            if (isJSONResponse(response)) {
                try {
                    json = decode(response.responseText);
                }
                catch (error) {
                }
            }
            response.responseJSON = json;
        }
        if (!json && isErrorCallback) {
            json = {};
        }
        if (json && !json.exception && isErrorCallback) {
            json.exception = response && response.statusText ? response.statusText : 'Communication failure.';
        }
        if (responseTransformer) {
            json = responseTransformer.call(scope || this, json);
        }
        if (fn) {
            fn.call(scope || this, json, response, options);
        }
        else if (isErrorCallback && response.status != 0) {
            alert('Error', json.exception);
        }
    };
}
function getCookie(name, defaultValue) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) == 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return defaultValue;
}
function getDateAltFormats() {
    const { useMDYDateParsing } = (0,_constants__WEBPACK_IMPORTED_MODULE_0__/* .getServerContext */ .$K)();
    return useMDYDateParsing ? DATEALTFORMATS_MonthDay : DATEALTFORMATS_DayMonth;
}
function getDateTimeFormatWithMS() {
    return DATETIMEFORMAT_WithMS;
}
function getFileIconUrl(fileName) {
    const idx = fileName.lastIndexOf('.');
    return (0,_ActionURL__WEBPACK_IMPORTED_MODULE_1__.buildURL)('core', 'getAttachmentIcon', '', {
        extension: idx >= 0 ? fileName.substring(idx + 1) : '_generic',
    });
}
function getMeasureAlias(measure, override) {
    if (measure.alias && !override) {
        return measure.alias;
    }
    const alias = measure.schemaName + '_' + measure.queryName + '_' + measure.name;
    return alias.replace(/\//g, '_');
}
function getMsgFromError(response, exceptionObj, config) {
    config = config || {};
    let error;
    const prefix = config.msgPrefix || 'An error occurred trying to load:\n';
    if (response && response.responseText && response.getResponseHeader('Content-Type')) {
        const contentType = response.getResponseHeader('Content-Type');
        if (contentType.indexOf('application/json') >= 0) {
            const jsonResponse = decode(response.responseText);
            if (jsonResponse && jsonResponse.exception) {
                error = prefix + jsonResponse.exception;
                if (config.showExceptionClass)
                    error +=
                        '\n(' +
                            (jsonResponse.exceptionClass ? jsonResponse.exceptionClass : 'Exception class unknown') +
                            ')';
            }
        }
    }
    if (!error) {
        error = prefix + 'Status: ' + response.statusText + ' (' + response.status + ')';
    }
    if (exceptionObj && exceptionObj.message) {
        error += '\n' + exceptionObj.name + ': ' + exceptionObj.message;
    }
    return error;
}
function getOnFailure(config) {
    return config.failure || config.errorCallback || config.failureCallback;
}
function getOnSuccess(config) {
    return config.success || config.successCallback;
}
function getSessionID() {
    return getCookie('JSESSIONID', '');
}
function id(prefix) {
    if (prefix) {
        return String(prefix) + ++idSeed;
    }
    return ID_PREFIX + ++idSeed;
}
function isArray(value) {
    return Object.prototype.toString.call(value) === '[object Array]';
}
function isBoolean(value) {
    const upperVal = value.toString().toUpperCase();
    if (upperVal == 'TRUE' ||
        value == '1' ||
        upperVal == 'Y' ||
        upperVal == 'YES' ||
        upperVal == 'ON' ||
        upperVal == 'T' ||
        upperVal == 'FALSE' ||
        value == '0' ||
        upperVal == 'N' ||
        upperVal == 'NO' ||
        upperVal == 'OFF' ||
        upperVal == 'F') {
        return true;
    }
}
function isDate(value) {
    return Object.prototype.toString.call(value) === '[object Date]';
}
function isNumber(value) {
    return typeof value === 'number' && Number.isFinite(value);
}
function isDefined(value) {
    return typeof value !== 'undefined';
}
function isEmptyObj(obj) {
    for (const i in obj) {
        return false;
    }
    return true;
}
function isFunction(value) {
    const getType = {};
    return value !== null && value !== undefined && getType.toString.call(value) === '[object Function]';
}
function isJSONResponse(response) {
    return (response &&
        response.getResponseHeader &&
        response.getResponseHeader('Content-Type') &&
        response.getResponseHeader('Content-Type').indexOf('application/json') >= 0);
}
function isObject(value) {
    return typeof value === 'object' && Object.prototype.toString.call(value) === '[object Object]';
}
function isString(value) {
    return typeof value === 'string';
}
function merge(...props) {
    const o = props[0];
    for (let i = 1; i < props.length; i++) {
        _merge(o, props[i], true, 50);
    }
    return o;
}
function mergeIf(...props) {
    const o = props[0];
    for (let i = 1; i < props.length; i++) {
        _merge(o, props[i], false, 50);
    }
    return o;
}
const onError = DOMWrapper('onError');
const onReady = DOMWrapper('onReady');
function onTrue(options) {
    options.maxTests = options.maxTests || 1000;
    try {
        if (options.testCallback.apply(options.scope || this, options.testArguments || [])) {
            getOnSuccess(options).apply(options.scope || this, options.successArguments || []);
        }
        else {
            if (options.maxTests <= 0) {
                throw 'Maximum number of tests reached!';
            }
            else {
                --options.maxTests;
            }
        }
    }
    catch (e) {
        if (getOnFailure(options)) {
            getOnFailure(options).apply(options.scope || this, [e, options.errorArguments]);
        }
    }
}
function padString(input, length, padChar) {
    let _input;
    if (!isString(input)) {
        _input = input.toString();
    }
    else {
        _input = input;
    }
    let pd = '';
    if (length > _input.length) {
        for (let i = 0; i < length - _input.length; i++) {
            pd += padChar;
        }
    }
    return pd + _input;
}
function parseDateString(dateString) {
    try {
        if (!!window.MSInputMethodContext && !!document.documentMode) {
            return parseDateStringIE11(dateString);
        }
        else {
            return new Date(dateString);
        }
    }
    catch (e) {
        throw 'Date string not in expected format. Expecting yyyy-MM-dd HH:mm:ss.SSS';
    }
}
function parseDateStringIE11(dateString) {
    const parts = dateString.split(' ');
    const dateParts = parts[0].split('-');
    const year = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10) - 1;
    const day = parseInt(dateParts[2], 10);
    const timeParts = parts[1].split(':');
    const hour = parseInt(timeParts[0], 10);
    const minute = parseInt(timeParts[1], 10);
    const secondParts = timeParts[2].split('.');
    const second = parseInt(secondParts[0], 10);
    const millisecond = parseInt(secondParts[1], 10);
    const values = [year, month, day, hour, minute, second, millisecond];
    if (values.some(isNaN)) {
        throw 'Invalid date string';
    }
    return new Date(year, month, day, hour, minute, second, millisecond);
}
function pluralBasic(count, singlar) {
    return pluralize(count, singlar, singlar + 's');
}
function pluralize(count, singular, plural) {
    return count.toLocaleString() + ' ' + (count === 1 ? singular : plural);
}
function requiresCSS(filePath) {
    const { requiresCss } = (0,_constants__WEBPACK_IMPORTED_MODULE_0__/* .getServerContext */ .$K)();
    requiresCss(filePath);
}
function requiresScript(file, callback, scope, inOrder) {
    const { requiresScript } = (0,_constants__WEBPACK_IMPORTED_MODULE_0__/* .getServerContext */ .$K)();
    requiresScript(file, callback, scope, inOrder);
}
function resizeToViewport() {
    console.warn('LABKEY.Utils.resizeToViewport has been migrated. See JavaScript API documentation for details.');
}
function roundNumber(input, dec) {
    return Math.round(input * Math.pow(10, dec)) / Math.pow(10, dec);
}
function setCookie(name, value, pageOnly, days) {
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
    }
    let path = '/';
    if (pageOnly) {
        path = location.pathname.substring(0, location.pathname.lastIndexOf('/'));
    }
    document.cookie = name + '=' + value + expires + '; path=' + path;
}
function textLink(options) {
    if (options.href === undefined && options.onClick === undefined) {
        throw 'href AND/OR onClick required in call to LABKEY.Utils.textLink()';
    }
    let attributes = ' ';
    if (options) {
        for (const i in options) {
            if (options.hasOwnProperty(i)) {
                if (i.toString() != 'text' && i.toString() != 'class') {
                    attributes += i.toString() + '="' + options[i] + '" ';
                }
            }
        }
        return '<a class="labkey-text-link"' + attributes + '>' + (options.text != null ? options.text : '') + '</a>';
    }
    throw 'Config object not found for textLink.';
}
function wafEncode(value) {
    if (isString(value) && value) {
        return '/*{{base64/x-www-form-urlencoded/wafText}}*/' + btoa(encodeURIComponent(value));
    }
    return value;
}


/***/ }),

/***/ 218:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $K: () => (/* binding */ getServerContext),
/* harmony export */   PO: () => (/* binding */ AuditBehaviorTypes),
/* harmony export */   Rj: () => (/* binding */ setGlobalUser),
/* harmony export */   ZA: () => (/* binding */ CSRF_HEADER),
/* harmony export */   g$: () => (/* binding */ getLocation),
/* harmony export */   sL: () => (/* binding */ ExperimentalFeatures)
/* harmony export */ });
var ExperimentalFeatures;
(function (ExperimentalFeatures) {
    ExperimentalFeatures["containerRelativeURL"] = "containerRelativeURL";
    ExperimentalFeatures["disableGuestAccount"] = "disableGuestAccount";
    ExperimentalFeatures["javascriptErrorServerLogging"] = "javascriptErrorServerLogging";
    ExperimentalFeatures["javascriptMothership"] = "javascriptMothership";
    ExperimentalFeatures["useExperimentalCoreUI"] = "useExperimentalCoreUI";
})(ExperimentalFeatures || (ExperimentalFeatures = {}));
var AuditBehaviorTypes;
(function (AuditBehaviorTypes) {
    AuditBehaviorTypes["DETAILED"] = "DETAILED";
    AuditBehaviorTypes["NONE"] = "NONE";
    AuditBehaviorTypes["SUMMARY"] = "SUMMARY";
})(AuditBehaviorTypes || (AuditBehaviorTypes = {}));
const CSRF_HEADER = 'X-LABKEY-CSRF';
function getLocation() {
    return window.location;
}
function getServerContext() {
    return LABKEY;
}
function setGlobalUser(user) {
    LABKEY.user = user;
    return LABKEY;
}
class _Window extends (/* unused pure expression or super */ null && (Window)) {
}
if (!window.LABKEY) {
    throw new Error('LABKEY object is required to be initialized prior to loading the API');
}


/***/ }),

/***/ 889:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Y: () => (/* binding */ Response),
/* harmony export */   f: () => (/* binding */ Row)
/* harmony export */ });
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(198);
/* harmony import */ var _FieldKey__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(932);
/* harmony import */ var _SchemaKey__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13);



function generateColumnModel(fields) {
    const columns = [];
    for (let i = 0; i < fields.length; i++) {
        columns.push({
            scale: fields[i].scale,
            hidden: fields[i].hidden,
            sortable: fields[i].sortable,
            align: fields[i].align,
            width: fields[i].width,
            dataIndex: fields[i].fieldKey.toString(),
            required: fields[i].nullable,
            editable: fields[i].userEditable,
            header: fields[i].shortCaption,
        });
    }
    return columns;
}
function generateGetDisplayField(fieldKey, fields) {
    return () => {
        const fieldString = fieldKey.toString();
        for (let i = 0; i < fields.length; i++) {
            if (fieldString === fields[i].fieldKey.toString()) {
                return fields[i];
            }
        }
        return null;
    };
}
class Response {
    constructor(rawResponse) {
        var _a, _b;
        for (const attr in rawResponse) {
            if (rawResponse.hasOwnProperty(attr)) {
                this[attr] = rawResponse[attr];
            }
        }
        this.schemaKey = _SchemaKey__WEBPACK_IMPORTED_MODULE_2__/* .SchemaKey */ .z.fromParts(rawResponse.schemaName);
        if (((_b = (_a = rawResponse.metaData) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            const fields = rawResponse.metaData.fields;
            for (let i = 0; i < fields.length; i++) {
                const field = Object.assign({}, fields[i]);
                const lookup = field.lookup;
                field.fieldKey = _FieldKey__WEBPACK_IMPORTED_MODULE_1__/* .FieldKey */ .W.fromParts(field.fieldKey);
                if (lookup && lookup.schemaName) {
                    lookup.schemaName = _SchemaKey__WEBPACK_IMPORTED_MODULE_2__/* .SchemaKey */ .z.fromParts(lookup.schemaName);
                }
                if (field.displayField) {
                    field.displayField = _FieldKey__WEBPACK_IMPORTED_MODULE_1__/* .FieldKey */ .W.fromParts(field.displayField);
                    field.getDisplayField = generateGetDisplayField(field.displayField, fields);
                }
                if (field.extFormatFn) {
                    const ext4Index = field.extFormatFn.indexOf('Ext4.'), isExt4Fn = ext4Index === 0 || ext4Index === 1, canEvalExt3 = !isExt4Fn && window && (0,_Utils__WEBPACK_IMPORTED_MODULE_0__.isDefined)(window.Ext), canEvalExt4 = isExt4Fn && window && (0,_Utils__WEBPACK_IMPORTED_MODULE_0__.isDefined)(window.Ext4);
                    if (canEvalExt3 || canEvalExt4) {
                        field.extFormatFn = eval(field.extFormatFn);
                    }
                }
                this.metaData.fields[i] = field;
            }
            this.columnModel = generateColumnModel(this.metaData.fields);
        }
        else {
            this.columnModel = [];
        }
        if (this.rows !== undefined) {
            for (let i = 0; i < this.rows.length; i++) {
                this.rows[i] = new Row(this.rows[i]);
            }
        }
        else {
            this.rows = [];
        }
    }
    getColumnModel() {
        return this.columnModel;
    }
    getMetaData() {
        return this.metaData;
    }
    getQueryName() {
        return this.queryName;
    }
    getRow(idx) {
        if (this.rows[idx] !== undefined) {
            return this.rows[idx];
        }
        throw new Error('No row found for index ' + idx);
    }
    getRowCount() {
        return this.rowCount;
    }
    getRows() {
        return this.rows;
    }
    getSchemaName(asString) {
        return asString ? this.schemaKey.toString() : this.schemaName;
    }
}
class Row {
    constructor(rawRow) {
        this.links = null;
        if (rawRow.links) {
            this.links = rawRow.links;
        }
        for (const attr in rawRow.data) {
            if (rawRow.data.hasOwnProperty(attr)) {
                this[attr] = rawRow.data[attr];
            }
        }
    }
    get(columnName) {
        columnName = columnName.toLowerCase();
        for (const attr in this) {
            if (attr.toLowerCase() === columnName && this.hasOwnProperty(attr) && !(0,_Utils__WEBPACK_IMPORTED_MODULE_0__.isFunction)(this[attr])) {
                return this[attr];
            }
        }
        return null;
    }
    getLink(linkType) {
        if (this.links && this.links.hasOwnProperty(linkType)) {
            return this.links[linkType];
        }
        return null;
    }
    getLinks() {
        return this.links;
    }
    getValue(columnName) {
        columnName = columnName.toLowerCase();
        for (const attr in this) {
            if (attr.toLowerCase() === columnName && this.hasOwnProperty(attr) && !(0,_Utils__WEBPACK_IMPORTED_MODULE_0__.isFunction)(this[attr])) {
                if ((0,_Utils__WEBPACK_IMPORTED_MODULE_0__.isArray)(this[attr])) {
                    return this[attr].map((i) => i.value);
                }
                if (this[attr].hasOwnProperty('value')) {
                    return this[attr].value;
                }
            }
        }
        return null;
    }
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ActionURL: () => (/* reexport */ ActionURL),
  Ajax: () => (/* reexport */ Ajax_namespaceObject),
  App: () => (/* reexport */ App_namespaceObject),
  Assay: () => (/* reexport */ Assay_namespaceObject),
  AssayDOM: () => (/* reexport */ dom_Assay_namespaceObject),
  AuditBehaviorTypes: () => (/* reexport */ constants/* AuditBehaviorTypes */.PO),
  Domain: () => (/* reexport */ Domain_namespaceObject),
  Exp: () => (/* reexport */ Exp_namespaceObject),
  Experiment: () => (/* reexport */ Experiment_namespaceObject),
  ExperimentalFeatures: () => (/* reexport */ constants/* ExperimentalFeatures */.sL),
  FieldKey: () => (/* reexport */ FieldKey/* FieldKey */.W),
  Filter: () => (/* reexport */ labkey_Filter_namespaceObject),
  List: () => (/* reexport */ List_namespaceObject),
  Message: () => (/* reexport */ Message_namespaceObject),
  MultiRequest: () => (/* reexport */ MultiRequest),
  ParticipantGroup: () => (/* reexport */ ParticipantGroup_namespaceObject),
  PermissionRoles: () => (/* reexport */ PermissionRoles),
  PermissionTypes: () => (/* reexport */ PermissionTypes),
  Pipeline: () => (/* reexport */ Pipeline_namespaceObject),
  Query: () => (/* reexport */ Query_namespaceObject),
  QueryDOM: () => (/* reexport */ dom_Query_namespaceObject),
  QueryKey: () => (/* reexport */ QueryKey/* QueryKey */.k),
  Report: () => (/* reexport */ Report_namespaceObject),
  SchemaKey: () => (/* reexport */ SchemaKey/* SchemaKey */.z),
  Security: () => (/* reexport */ Security_namespaceObject),
  Specimen: () => (/* reexport */ Specimen_namespaceObject),
  Storage: () => (/* reexport */ Storage_namespaceObject),
  Utils: () => (/* reexport */ Utils),
  UtilsDOM: () => (/* reexport */ dom_Utils_namespaceObject),
  Visualization: () => (/* reexport */ labkey_Visualization_namespaceObject),
  getServerContext: () => (/* reexport */ constants/* getServerContext */.$K)
});

// NAMESPACE OBJECT: ./src/labkey/Ajax.ts
var Ajax_namespaceObject = {};
__webpack_require__.r(Ajax_namespaceObject);
__webpack_require__.d(Ajax_namespaceObject, {
  DEFAULT_HEADERS: () => (DEFAULT_HEADERS),
  getFilenameFromContentDisposition: () => (getFilenameFromContentDisposition),
  request: () => (request)
});

// NAMESPACE OBJECT: ./src/labkey/App.ts
var App_namespaceObject = {};
__webpack_require__.r(App_namespaceObject);
__webpack_require__.d(App_namespaceObject, {
  init: () => (init),
  loadApp: () => (loadApp),
  registerApp: () => (registerApp)
});

// NAMESPACE OBJECT: ./src/labkey/Assay.ts
var Assay_namespaceObject = {};
__webpack_require__.r(Assay_namespaceObject);
__webpack_require__.d(Assay_namespaceObject, {
  AssayLink: () => (AssayLink),
  getAll: () => (getAll),
  getAssays: () => (getAssays),
  getById: () => (getById),
  getByName: () => (getByName),
  getByType: () => (getByType),
  getNAbRuns: () => (getNAbRuns),
  getStudyNabGraphURL: () => (getStudyNabGraphURL),
  getStudyNabRuns: () => (getStudyNabRuns)
});

// NAMESPACE OBJECT: ./src/labkey/Domain.ts
var Domain_namespaceObject = {};
__webpack_require__.r(Domain_namespaceObject);
__webpack_require__.d(Domain_namespaceObject, {
  KINDS: () => (KINDS),
  create: () => (Domain_create),
  drop: () => (drop),
  get: () => (get),
  getDomainDetails: () => (getDomainDetails),
  getDomainNamePreviews: () => (getDomainNamePreviews),
  getProperties: () => (getProperties),
  getPropertyUsages: () => (getPropertyUsages),
  listDomains: () => (listDomains),
  save: () => (save),
  updateDomain: () => (updateDomain),
  validateNameExpressions: () => (validateNameExpressions)
});

// NAMESPACE OBJECT: ./src/labkey/Exp.ts
var Exp_namespaceObject = {};
__webpack_require__.r(Exp_namespaceObject);
__webpack_require__.d(Exp_namespaceObject, {
  ChildObject: () => (ChildObject),
  Data: () => (Data),
  DataClass: () => (DataClass),
  ExpObject: () => (ExpObject),
  Material: () => (Material),
  Protocol: () => (Protocol),
  ProtocolApplication: () => (ProtocolApplication),
  Run: () => (Run),
  RunGroup: () => (RunGroup),
  RunItem: () => (RunItem),
  SampleSet: () => (SampleSet)
});

// NAMESPACE OBJECT: ./src/labkey/Experiment.ts
var Experiment_namespaceObject = {};
__webpack_require__.r(Experiment_namespaceObject);
__webpack_require__.d(Experiment_namespaceObject, {
  SAMPLE_ALIQUOT_PROTOCOL: () => (SAMPLE_ALIQUOT_PROTOCOL),
  SAMPLE_DERIVATION_PROTOCOL: () => (SAMPLE_DERIVATION_PROTOCOL),
  createHiddenRunGroup: () => (createHiddenRunGroup),
  exportRuns: () => (exportRuns),
  getEntitySequence: () => (getEntitySequence),
  lineage: () => (lineage),
  loadBatch: () => (loadBatch),
  loadBatches: () => (loadBatches),
  loadRuns: () => (loadRuns),
  resolve: () => (resolve),
  saveBatch: () => (saveBatch),
  saveBatches: () => (saveBatches),
  saveMaterials: () => (saveMaterials),
  saveRuns: () => (saveRuns),
  setEntitySequence: () => (setEntitySequence)
});

// NAMESPACE OBJECT: ./src/labkey/Filter.ts
var labkey_Filter_namespaceObject = {};
__webpack_require__.r(labkey_Filter_namespaceObject);
__webpack_require__.d(labkey_Filter_namespaceObject, {
  Types: () => (Types),
  _define: () => (_define),
  appendAggregateParams: () => (appendAggregateParams),
  appendFilterParams: () => (appendFilterParams),
  create: () => (create),
  getDefaultFilterForType: () => (getDefaultFilterForType),
  getFilterDescription: () => (getFilterDescription),
  getFilterTypeForURLSuffix: () => (getFilterTypeForURLSuffix),
  getFilterTypesForType: () => (getFilterTypesForType),
  getFiltersFromParameters: () => (getFiltersFromParameters),
  getFiltersFromUrl: () => (getFiltersFromUrl),
  getQueryParamsFromUrl: () => (getQueryParamsFromUrl),
  getSortFromUrl: () => (getSortFromUrl),
  merge: () => (merge),
  registerFilterType: () => (registerFilterType)
});

// NAMESPACE OBJECT: ./src/labkey/List.ts
var List_namespaceObject = {};
__webpack_require__.r(List_namespaceObject);
__webpack_require__.d(List_namespaceObject, {
  create: () => (List_create)
});

// NAMESPACE OBJECT: ./src/labkey/Message.ts
var Message_namespaceObject = {};
__webpack_require__.r(Message_namespaceObject);
__webpack_require__.d(Message_namespaceObject, {
  createMsgContent: () => (createMsgContent),
  createPrincipalIdRecipient: () => (createPrincipalIdRecipient),
  createRecipient: () => (createRecipient),
  msgType: () => (msgType),
  recipientType: () => (recipientType),
  sendMessage: () => (sendMessage)
});

// NAMESPACE OBJECT: ./src/labkey/ParticipantGroup.ts
var ParticipantGroup_namespaceObject = {};
__webpack_require__.r(ParticipantGroup_namespaceObject);
__webpack_require__.d(ParticipantGroup_namespaceObject, {
  updateParticipantGroup: () => (updateParticipantGroup)
});

// NAMESPACE OBJECT: ./src/labkey/Pipeline.ts
var Pipeline_namespaceObject = {};
__webpack_require__.r(Pipeline_namespaceObject);
__webpack_require__.d(Pipeline_namespaceObject, {
  getFileStatus: () => (getFileStatus),
  getPipelineContainer: () => (getPipelineContainer),
  getProtocols: () => (getProtocols),
  startAnalysis: () => (startAnalysis)
});

// NAMESPACE OBJECT: ./src/labkey/query/GetData.ts
var GetData_namespaceObject = {};
__webpack_require__.r(GetData_namespaceObject);
__webpack_require__.d(GetData_namespaceObject, {
  getRawData: () => (getRawData)
});

// NAMESPACE OBJECT: ./src/labkey/query/experimental/SQL.ts
var SQL_namespaceObject = {};
__webpack_require__.r(SQL_namespaceObject);
__webpack_require__.d(SQL_namespaceObject, {
  asObjects: () => (asObjects),
  execute: () => (execute)
});

// NAMESPACE OBJECT: ./src/labkey/query/visualization/Filter.ts
var visualization_Filter_namespaceObject = {};
__webpack_require__.r(visualization_Filter_namespaceObject);
__webpack_require__.d(visualization_Filter_namespaceObject, {
  QueryType: () => (QueryType),
  create: () => (Filter_create)
});

// NAMESPACE OBJECT: ./src/labkey/query/Visualization.ts
var Visualization_namespaceObject = {};
__webpack_require__.r(Visualization_namespaceObject);
__webpack_require__.d(Visualization_namespaceObject, {
  Aggregate: () => (Aggregate),
  Dimension: () => (Dimension),
  Filter: () => (visualization_Filter_namespaceObject),
  Interval: () => (Interval),
  Measure: () => (Measure),
  Type: () => (Type),
  get: () => (Visualization_get),
  getData: () => (getData),
  getDataFilterFromURL: () => (getDataFilterFromURL),
  getFromUrl: () => (getFromUrl),
  getMeasures: () => (getMeasures),
  getTypes: () => (getTypes),
  save: () => (Visualization_save)
});

// NAMESPACE OBJECT: ./src/labkey/Query.ts
var Query_namespaceObject = {};
__webpack_require__.r(Query_namespaceObject);
__webpack_require__.d(Query_namespaceObject, {
  ContainerFilter: () => (ContainerFilter),
  Filter: () => (Filter),
  GetData: () => (GetData_namespaceObject),
  Response: () => (Response/* Response */.Y),
  Row: () => (Response/* Row */.f),
  URL_COLUMN_PREFIX: () => (URL_COLUMN_PREFIX),
  Visualization: () => (Visualization_namespaceObject),
  buildQueryParams: () => (buildQueryParams),
  containerFilter: () => (containerFilter),
  deleteQueryView: () => (deleteQueryView),
  deleteRows: () => (deleteRows),
  executeSql: () => (executeSql),
  experimental: () => (experimental),
  getDataViews: () => (getDataViews),
  getQueries: () => (getQueries),
  getQueryDetails: () => (getQueryDetails),
  getQueryViews: () => (getQueryViews),
  getSchemas: () => (getSchemas),
  getServerDate: () => (getServerDate),
  insertRows: () => (insertRows),
  moveRows: () => (moveRows),
  saveQueryViews: () => (saveQueryViews),
  saveRows: () => (saveRows),
  saveSessionView: () => (saveSessionView),
  selectDistinctRows: () => (selectDistinctRows),
  selectRows: () => (selectRows),
  sqlDateLiteral: () => (sqlDateLiteral),
  sqlDateTimeLiteral: () => (sqlDateTimeLiteral),
  sqlStringLiteral: () => (sqlStringLiteral),
  truncateTable: () => (truncateTable),
  updateRows: () => (updateRows),
  validateQuery: () => (validateQuery)
});

// NAMESPACE OBJECT: ./src/labkey/Report.ts
var Report_namespaceObject = {};
__webpack_require__.r(Report_namespaceObject);
__webpack_require__.d(Report_namespaceObject, {
  createSession: () => (createSession),
  deleteSession: () => (deleteSession),
  execute: () => (Report_execute),
  executeFunction: () => (executeFunction),
  getSessions: () => (getSessions)
});

// NAMESPACE OBJECT: ./src/labkey/Security.ts
var Security_namespaceObject = {};
__webpack_require__.r(Security_namespaceObject);
__webpack_require__.d(Security_namespaceObject, {
  PermissionRoles: () => (PermissionRoles),
  PermissionTypes: () => (PermissionTypes),
  addGroupMembers: () => (addGroupMembers),
  createContainer: () => (createContainer),
  createGroup: () => (createGroup),
  createNewUser: () => (createNewUser),
  currentContainer: () => (currentContainer),
  currentUser: () => (currentUser),
  deleteContainer: () => (deleteContainer),
  deleteGroup: () => (deleteGroup),
  deletePolicy: () => (deletePolicy),
  effectivePermissions: () => (effectivePermissions),
  ensureLogin: () => (ensureLogin),
  getContainers: () => (getContainers),
  getFolderTypes: () => (getFolderTypes),
  getGroupPermissions: () => (getGroupPermissions),
  getGroupsForCurrentUser: () => (getGroupsForCurrentUser),
  getHomeContainer: () => (getHomeContainer),
  getModules: () => (getModules),
  getPolicy: () => (getPolicy),
  getReadableContainers: () => (getReadableContainers),
  getRole: () => (getRole),
  getRoles: () => (getRoles),
  getSchemaPermissions: () => (getSchemaPermissions),
  getSecurableResources: () => (getSecurableResources),
  getSharedContainer: () => (getSharedContainer),
  getUserPermissions: () => (getUserPermissions),
  getUsers: () => (getUsers),
  getUsersWithPermissions: () => (getUsersWithPermissions),
  hasEffectivePermission: () => (hasEffectivePermission),
  hasPermission: () => (hasPermission),
  moveContainer: () => (moveContainer),
  permissions: () => (permissions),
  removeGroupMembers: () => (removeGroupMembers),
  renameContainer: () => (renameContainer),
  renameGroup: () => (renameGroup),
  roles: () => (roles),
  savePolicy: () => (savePolicy),
  systemGroups: () => (systemGroups)
});

// NAMESPACE OBJECT: ./src/labkey/Specimen.ts
var Specimen_namespaceObject = {};
__webpack_require__.r(Specimen_namespaceObject);
__webpack_require__.d(Specimen_namespaceObject, {
  addSamplesToRequest: () => (addSamplesToRequest),
  addSpecimensToRequest: () => (addSpecimensToRequest),
  addVialsToRequest: () => (addVialsToRequest),
  cancelRequest: () => (cancelRequest),
  getOpenRequests: () => (getOpenRequests),
  getProvidingLocations: () => (getProvidingLocations),
  getRepositories: () => (getRepositories),
  getRequest: () => (getRequest),
  getSpecimenWebPartGroups: () => (getSpecimenWebPartGroups),
  getVialTypeSummary: () => (getVialTypeSummary),
  getVialsByRowId: () => (getVialsByRowId),
  removeVialsFromRequest: () => (removeVialsFromRequest)
});

// NAMESPACE OBJECT: ./src/labkey/Storage.ts
var Storage_namespaceObject = {};
__webpack_require__.r(Storage_namespaceObject);
__webpack_require__.d(Storage_namespaceObject, {
  STORAGE_TYPES: () => (STORAGE_TYPES),
  createStorageItem: () => (createStorageItem),
  deleteStorageItem: () => (deleteStorageItem),
  updateStorageItem: () => (updateStorageItem)
});

// NAMESPACE OBJECT: ./src/labkey/Visualization.ts
var labkey_Visualization_namespaceObject = {};
__webpack_require__.r(labkey_Visualization_namespaceObject);
__webpack_require__.d(labkey_Visualization_namespaceObject, {
  Aggregate: () => (Aggregate),
  Dimension: () => (Dimension),
  Filter: () => (visualization_Filter_namespaceObject),
  Interval: () => (Interval),
  Measure: () => (Measure),
  Type: () => (Type),
  get: () => (Visualization_get),
  getData: () => (getData),
  getDataFilterFromURL: () => (getDataFilterFromURL),
  getFromUrl: () => (getFromUrl),
  getMeasures: () => (getMeasures),
  getTypes: () => (getTypes),
  save: () => (Visualization_save)
});

// NAMESPACE OBJECT: ./src/labkey/dom/Assay.ts
var dom_Assay_namespaceObject = {};
__webpack_require__.r(dom_Assay_namespaceObject);
__webpack_require__.d(dom_Assay_namespaceObject, {
  importRun: () => (importRun)
});

// NAMESPACE OBJECT: ./src/labkey/dom/Utils.ts
var dom_Utils_namespaceObject = {};
__webpack_require__.r(dom_Utils_namespaceObject);
__webpack_require__.d(dom_Utils_namespaceObject, {
  DelimiterType: () => (DelimiterType),
  QuoteCharType: () => (QuoteCharType),
  alert: () => (Utils_alert),
  confirmAndPost: () => (confirmAndPost),
  convertToExcel: () => (convertToExcel),
  convertToTable: () => (convertToTable),
  displayAjaxErrorResponse: () => (displayAjaxErrorResponse),
  getMsgFromError: () => (getMsgFromError),
  postToAction: () => (postToAction),
  setWebpartTitle: () => (setWebpartTitle),
  signalWebDriverTest: () => (signalWebDriverTest)
});

// NAMESPACE OBJECT: ./src/labkey/dom/Query.ts
var dom_Query_namespaceObject = {};
__webpack_require__.r(dom_Query_namespaceObject);
__webpack_require__.d(dom_Query_namespaceObject, {
  exportSql: () => (exportSql),
  exportTables: () => (exportTables),
  importData: () => (importData)
});

// EXTERNAL MODULE: ./src/labkey/constants.ts
var constants = __webpack_require__(218);
;// CONCATENATED MODULE: ./src/labkey/security/constants.ts

const currentContainer = (0,constants/* getServerContext */.$K)().container;
const currentUser = (0,constants/* getServerContext */.$K)().user;
var PermissionRoles;
(function (PermissionRoles) {
    PermissionRoles["ApplicationAdmin"] = "org.labkey.api.security.roles.ApplicationAdminRole";
    PermissionRoles["Author"] = "org.labkey.api.security.roles.AuthorRole";
    PermissionRoles["Editor"] = "org.labkey.api.security.roles.EditorRole";
    PermissionRoles["EditorWithoutDelete"] = "org.labkey.api.security.roles.EditorWithoutDeleteRole";
    PermissionRoles["FolderAdmin"] = "org.labkey.api.security.roles.FolderAdminRole";
    PermissionRoles["ProjectAdmin"] = "org.labkey.api.security.roles.ProjectAdminRole";
    PermissionRoles["Reader"] = "org.labkey.api.security.roles.ReaderRole";
})(PermissionRoles || (PermissionRoles = {}));
var PermissionTypes;
(function (PermissionTypes) {
    PermissionTypes["AddUser"] = "org.labkey.api.security.permissions.AddUserPermission";
    PermissionTypes["Admin"] = "org.labkey.api.security.permissions.AdminPermission";
    PermissionTypes["AdminOperationsPermission"] = "org.labkey.api.security.permissions.AdminOperationsPermission";
    PermissionTypes["ApplicationAdmin"] = "org.labkey.api.security.permissions.ApplicationAdminPermission";
    PermissionTypes["CanSeeAuditLog"] = "org.labkey.api.audit.permissions.CanSeeAuditLogPermission";
    PermissionTypes["CanSeeGroupDetails"] = "org.labkey.api.security.permissions.SeeGroupDetailsPermission";
    PermissionTypes["CanSeeUserDetails"] = "org.labkey.api.security.permissions.SeeUserDetailsPermission";
    PermissionTypes["Delete"] = "org.labkey.api.security.permissions.DeletePermission";
    PermissionTypes["DesignAssay"] = "org.labkey.api.assay.security.DesignAssayPermission";
    PermissionTypes["DesignDataClass"] = "org.labkey.api.security.permissions.DesignDataClassPermission";
    PermissionTypes["DesignList"] = "org.labkey.api.lists.permissions.DesignListPermission";
    PermissionTypes["DesignSampleSet"] = "org.labkey.api.security.permissions.DesignSampleTypePermission";
    PermissionTypes["DesignStorage"] = "org.labkey.api.inventory.security.StorageDesignPermission";
    PermissionTypes["EditSharedView"] = "org.labkey.api.security.permissions.EditSharedViewPermission";
    PermissionTypes["EditStorageData"] = "org.labkey.api.inventory.security.StorageDataUpdatePermission";
    PermissionTypes["Insert"] = "org.labkey.api.security.permissions.InsertPermission";
    PermissionTypes["ManagePicklists"] = "org.labkey.api.lists.permissions.ManagePicklistsPermission";
    PermissionTypes["ManageSampleWorkflows"] = "org.labkey.api.security.permissions.SampleWorkflowJobPermission";
    PermissionTypes["MoveEntities"] = "org.labkey.api.security.permissions.MoveEntitiesPermission";
    PermissionTypes["QCAnalyst"] = "org.labkey.api.security.permissions.QCAnalystPermission";
    PermissionTypes["Read"] = "org.labkey.api.security.permissions.ReadPermission";
    PermissionTypes["ReadAssay"] = "org.labkey.api.security.permissions.AssayReadPermission";
    PermissionTypes["ReadDataClass"] = "org.labkey.api.security.permissions.DataClassReadPermission";
    PermissionTypes["ReadMedia"] = "org.labkey.api.security.permissions.MediaReadPermission";
    PermissionTypes["ReadNotebooks"] = "org.labkey.api.security.permissions.NotebookReadPermission";
    PermissionTypes["ReadSome"] = "org.labkey.api.security.permissions.ReadSomePermission";
    PermissionTypes["SampleWorkflowDelete"] = "org.labkey.api.security.permissions.SampleWorkflowDeletePermission";
    PermissionTypes["ShareReportPermission"] = "org.labkey.api.reports.permissions.ShareReportPermission";
    PermissionTypes["Update"] = "org.labkey.api.security.permissions.UpdatePermission";
    PermissionTypes["UserManagement"] = "org.labkey.api.security.permissions.UserManagementPermission";
})(PermissionTypes || (PermissionTypes = {}));
const effectivePermissions = {
    insert: PermissionTypes.Insert,
    read: PermissionTypes.Read,
    admin: PermissionTypes.Admin,
    del: PermissionTypes.Delete,
    readOwn: PermissionTypes.ReadSome,
    update: PermissionTypes.Update,
};
const permissions = {
    read: 1,
    insert: 2,
    update: 4,
    del: 8,
    readOwn: 16,
    updateOwn: 64,
    deleteOwn: 128,
    admin: 32768,
    all: 65535,
};
const roles = {
    admin: 65535,
    editor: 15,
    author: 195,
    reader: 1,
    restrictedReader: 16,
    submitter: 2,
    noPerms: 0,
};
const systemGroups = {
    administrators: -1,
    users: -2,
    guests: -3,
    developers: -4,
};

// EXTERNAL MODULE: ./src/labkey/ActionURL.ts
var ActionURL = __webpack_require__(72);
;// CONCATENATED MODULE: ./src/labkey/Ajax.ts


const { CSRF, defaultHeaders } = (0,constants/* getServerContext */.$K)();
let DEFAULT_HEADERS = {
    [constants/* CSRF_HEADER */.ZA]: CSRF,
};
if (defaultHeaders) {
    DEFAULT_HEADERS = defaultHeaders;
}
function callback(fn, scope, args) {
    if (fn) {
        fn.apply(scope, args);
    }
}
function contains(obj, key) {
    if (key) {
        const lowerKey = key.toLowerCase();
        for (const k in obj) {
            if (obj.hasOwnProperty(k) && k.toLowerCase() === lowerKey) {
                return true;
            }
        }
    }
    return false;
}
function configureHeaders(xhr, config, options) {
    let headers = config.headers, jsonData = config.jsonData;
    if (headers === undefined || headers === null) {
        headers = {};
    }
    if (!options.isForm && !contains(headers, 'Content-Type')) {
        if (jsonData !== undefined && jsonData !== null) {
            headers['Content-Type'] = 'application/json';
        }
        else {
            headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        }
    }
    if (!contains(headers, 'X-Requested-With')) {
        headers['X-Requested-With'] = 'XMLHttpRequest';
    }
    for (const k in DEFAULT_HEADERS) {
        if (DEFAULT_HEADERS.hasOwnProperty(k)) {
            xhr.setRequestHeader(k, DEFAULT_HEADERS[k]);
        }
    }
    for (const k in headers) {
        if (headers.hasOwnProperty(k)) {
            xhr.setRequestHeader(k, headers[k]);
        }
    }
}
function configureOptions(config) {
    let data;
    let formData;
    let method = 'GET';
    let isForm = false;
    if (!config || !config.hasOwnProperty('url') || config.url === null) {
        throw new Error('a URL is required to make a request');
    }
    let url = config.url;
    const params = config.params;
    if (config.form) {
        formData =
            config.form instanceof FormData ? config.form : new FormData(config.form);
        isForm = true;
    }
    else if (config.jsonData) {
        data = JSON.stringify(config.jsonData);
    }
    if (config.hasOwnProperty('method') && config.method !== null) {
        method = config.method.toUpperCase();
    }
    else if (data) {
        method = 'POST';
    }
    if (params !== undefined && params !== null) {
        const qs = (0,ActionURL.queryString)(params);
        if (method === 'POST' && (data === undefined || data === null)) {
            data = qs;
        }
        else {
            url += (url.indexOf('?') === -1 ? '?' : '&') + qs;
        }
    }
    return {
        data: isForm ? formData : data,
        isForm,
        method,
        url,
    };
}
function getFilenameFromContentDisposition(disposition) {
    var filename;
    if (disposition && disposition.startsWith('attachment')) {
        const matches = /filename\*?=([^']*'')?(['"].*?['"]|[^;\n]*)/.exec(disposition);
        if (matches && matches[2]) {
            filename = decodeURI(matches[2].replace(/['"]/g, ''));
        }
    }
    return filename;
}
function downloadFile(xhr, config) {
    let filename = '';
    if (typeof config.downloadFile === 'string') {
        filename = config.downloadFile;
    }
    else {
        filename = getFilenameFromContentDisposition(xhr.getResponseHeader('Content-Disposition'));
    }
    const blob = xhr.response;
    const downloadUrl = URL.createObjectURL(blob);
    if (filename) {
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
    }
    else {
        window.location.href = downloadUrl;
    }
    setTimeout(() => {
        URL.revokeObjectURL(downloadUrl);
    }, 100);
}
function request(config) {
    const options = configureOptions(config);
    const scope = config.hasOwnProperty('scope') && config.scope !== null ? config.scope : this;
    const xhr = new XMLHttpRequest();
    if (config.downloadFile) {
        xhr.responseType = 'blob';
    }
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            const success = (xhr.status >= 200 && xhr.status < 300) || xhr.status == 304;
            if (success && config.downloadFile) {
                downloadFile(xhr, config);
            }
            callback(success ? config.success : config.failure, scope, [xhr, config]);
            callback(config.callback, scope, [config, success, xhr]);
        }
        else if (xhr.readyState === 2 && xhr.responseType === 'blob') {
            const success = (xhr.status >= 200 && xhr.status < 300) || xhr.status == 304;
            if (!success) {
                xhr.responseType = 'text';
            }
        }
    };
    xhr.open(options.method, options.url, true);
    configureHeaders(xhr, config, options);
    if (config.hasOwnProperty('timeout') && config.timeout !== null && config.timeout !== undefined) {
        xhr.ontimeout = function () {
            callback(config.failure, scope, [xhr, config]);
            callback(config.callback, scope, [config, false, xhr]);
        };
    }
    xhr.send(options.data);
    return xhr;
}

;// CONCATENATED MODULE: ./src/labkey/App.ts
function getRegistry() {
    if (!LABKEY.App.__app__) {
        throw new Error('App registry not initialized. Must call init() prior to getRegistry()');
    }
    return LABKEY.App.__app__;
}
function init(LABKEY) {
    if (LABKEY === null || LABKEY === void 0 ? void 0 : LABKEY.App) {
        if (!LABKEY.App.__app__) {
            LABKEY.App.__app__ = {
                isDOMContentLoaded: document.readyState !== 'loading',
                registry: {},
            };
            document.addEventListener('readystatechange', event => {
                LABKEY.App.__app__.isDOMContentLoaded = document.readyState !== 'loading';
            });
        }
    }
    else {
        console.log('LABKEY.App is not available. Unable to initialize application registry.');
    }
}
function loadApp(appName, appTarget, appContext) {
    const appRegistry = getRegistry();
    if (appRegistry.registry.hasOwnProperty(appName)) {
        if (appRegistry.registry[appName].hot) {
            appRegistry.registry[appName].contexts.push(appContext);
            appRegistry.registry[appName].targets.push(appTarget);
        }
        if (appRegistry.isDOMContentLoaded) {
            appRegistry.registry[appName].onInit(appTarget, appContext);
        }
        else {
            window.addEventListener('DOMContentLoaded', () => {
                appRegistry.registry[appName].onInit(appTarget, appContext);
            }, { once: true });
        }
    }
    else {
        throw Error(`Application "${appName}" is not a registered application. Unable to initialize.`);
    }
}
function registerApp(appName, onInit, hot) {
    const appRegistry = getRegistry();
    if (!appRegistry.registry.hasOwnProperty(appName)) {
        appRegistry.registry[appName] = {
            appName,
            contexts: [],
            hot: hot === true,
            onInit,
            targets: [],
        };
    }
    else if (appRegistry.registry[appName].hot) {
        runHot(appRegistry.registry[appName]);
    }
}
function runHot(item) {
    if (!item.hot) {
        throw Error(`Attempting to run application ${item.appName} hot when hot is not enabled.`);
    }
    if (item.targets.length !== item.contexts.length) {
        throw Error(`Application registry for "${item.appName}" is in an invalid state. Expected targets and contexts to align.`);
    }
    for (let i = 0; i < item.targets.length; i++) {
        item.onInit(item.targets[i], item.contexts[i]);
    }
}

// EXTERNAL MODULE: ./src/labkey/Utils.ts
var Utils = __webpack_require__(198);
// EXTERNAL MODULE: ./src/labkey/FieldKey.ts
var FieldKey = __webpack_require__(932);
;// CONCATENATED MODULE: ./src/labkey/filter/constants.ts
const multiValueToSingleMap = {
    in: 'eq',
    containsoneof: 'contains',
    containsnoneof: 'doesnotcontain',
    between: 'gte',
    notbetween: 'lt',
};
const oppositeMap = {
    eq: 'neqornull',
    dateeq: 'dateneq',
    dateneq: 'dateeq',
    neqornull: 'eq',
    neq: 'eq',
    isblank: 'isnonblank',
    isnonblank: 'isblank',
    gt: 'lte',
    dategt: 'datelte',
    lt: 'gte',
    datelt: 'dategte',
    gte: 'lt',
    dategte: 'datelt',
    lte: 'gt',
    datelte: 'dategt',
    contains: 'doesnotcontain',
    doesnotcontain: 'contains',
    doesnotstartwith: 'startswith',
    startswith: 'doesnotstartwith',
    in: 'notin',
    notin: 'in',
    memberof: 'memberof',
    containsoneof: 'containsnoneof',
    containsnoneof: 'containsoneof',
    hasmvvalue: 'nomvvalue',
    nomvvalue: 'hasmvvalue',
    between: 'notbetween',
    notbetween: 'between',
    insubtree: 'notinsubtree',
    notinsubtree: 'insubtree',
};
const singleValueToMultiMap = {
    eq: 'in',
    neq: 'notin',
    neqornull: 'notin',
    doesnotcontain: 'containsnoneof',
    contains: 'containsoneof',
};

;// CONCATENATED MODULE: ./src/labkey/filter/Types.ts


const urlMap = {};
const EQUAL = registerFilterType('Equals', '=', 'eq', true, undefined, undefined, undefined, undefined, false, '=');
const GREATER_THAN = registerFilterType('Is Greater Than', '>', 'gt', true, undefined, undefined, undefined, undefined, false, '>');
const GREATER_THAN_OR_EQUAL = registerFilterType('Is Greater Than or Equal To', '>=', 'gte', true, undefined, undefined, undefined, undefined, false, '>=');
const IN = registerFilterType('Equals One Of', null, 'in', true, ';', 'Equals One Of');
const LESS_THAN = registerFilterType('Is Less Than', '<', 'lt', true, undefined, undefined, undefined, undefined, false, '<');
const LESS_THAN_OR_EQUAL = registerFilterType('Is Less Than or Equal To', '=<', 'lte', true, undefined, undefined, undefined, undefined, false, '<=');
const NOT_EQUAL = registerFilterType('Does Not Equal', '<>', 'neq', true, undefined, undefined, undefined, undefined, false, '<>');
const NOT_IN = registerFilterType('Does Not Equal Any Of', null, 'notin', true, ';', 'Does Not Equal Any Of');
const NEQ_OR_NULL = registerFilterType(NOT_EQUAL.getDisplayText(), NOT_EQUAL.getDisplaySymbol(), 'neqornull', true);
const Types = {
    EQUAL,
    DATE_EQUAL: registerFilterType(EQUAL.getDisplayText(), EQUAL.getDisplaySymbol(), 'dateeq', true, undefined, undefined, undefined, undefined, false, EQUAL.getLabKeySqlOperator()),
    NOT_EQUAL,
    NEQ: NOT_EQUAL,
    DATE_NOT_EQUAL: registerFilterType(NOT_EQUAL.getDisplayText(), NOT_EQUAL.getDisplaySymbol(), 'dateneq', true, undefined, undefined, undefined, undefined, false, NOT_EQUAL.getLabKeySqlOperator()),
    NEQ_OR_NULL,
    NOT_EQUAL_OR_MISSING: NEQ_OR_NULL,
    GREATER_THAN,
    GT: GREATER_THAN,
    DATE_GREATER_THAN: registerFilterType(GREATER_THAN.getDisplayText(), GREATER_THAN.getDisplaySymbol(), 'dategt', true, undefined, undefined, undefined, undefined, false, GREATER_THAN.getLabKeySqlOperator()),
    LESS_THAN,
    LT: LESS_THAN,
    DATE_LESS_THAN: registerFilterType(LESS_THAN.getDisplayText(), LESS_THAN.getDisplaySymbol(), 'datelt', true, undefined, undefined, undefined, undefined, false, LESS_THAN.getLabKeySqlOperator()),
    GREATER_THAN_OR_EQUAL,
    GTE: GREATER_THAN_OR_EQUAL,
    DATE_GREATER_THAN_OR_EQUAL: registerFilterType(GREATER_THAN_OR_EQUAL.getDisplayText(), GREATER_THAN_OR_EQUAL.getDisplaySymbol(), 'dategte', true, undefined, undefined, undefined, undefined, false, GREATER_THAN_OR_EQUAL.getLabKeySqlOperator()),
    LESS_THAN_OR_EQUAL,
    LTE: LESS_THAN_OR_EQUAL,
    DATE_LESS_THAN_OR_EQUAL: registerFilterType(LESS_THAN_OR_EQUAL.getDisplayText(), LESS_THAN_OR_EQUAL.getDisplaySymbol(), 'datelte', true, undefined, undefined, undefined, undefined, false, LESS_THAN_OR_EQUAL.getLabKeySqlOperator()),
    STARTS_WITH: registerFilterType('Starts With', null, 'startswith', true),
    DOES_NOT_START_WITH: registerFilterType('Does Not Start With', null, 'doesnotstartwith', true),
    CONTAINS: registerFilterType('Contains', null, 'contains', true),
    DOES_NOT_CONTAIN: registerFilterType('Does Not Contain', null, 'doesnotcontain', true),
    CONTAINS_ONE_OF: registerFilterType('Contains One Of', null, 'containsoneof', true, ';', 'Contains One Of'),
    CONTAINS_NONE_OF: registerFilterType('Does Not Contain Any Of', null, 'containsnoneof', true, ';', 'Does Not Contain Any Of'),
    IN,
    EQUALS_ONE_OF: IN,
    NOT_IN,
    EQUALS_NONE_OF: NOT_IN,
    BETWEEN: registerFilterType('Between', null, 'between', true, ',', 'Between, Inclusive (example usage: -4,4)', 2, 2),
    NOT_BETWEEN: registerFilterType('Not Between', null, 'notbetween', true, ',', 'Not Between, Exclusive (example usage: -4,4)', 2, 2),
    MEMBER_OF: registerFilterType('Member Of', null, 'memberof', true, undefined, 'Member Of'),
    HAS_ANY_VALUE: registerFilterType('Has Any Value', null, ''),
    ISBLANK: registerFilterType('Is Blank', null, 'isblank', false, undefined, undefined, undefined, undefined, false, 'IS NULL'),
    MISSING: registerFilterType('Is Blank', null, 'isblank', false, undefined, undefined, undefined, undefined, false, 'IS NULL'),
    NONBLANK: registerFilterType('Is Not Blank', null, 'isnonblank', false, undefined, undefined, undefined, undefined, false, 'IS NOT NULL'),
    NOT_MISSING: registerFilterType('Is Not Blank', null, 'isnonblank', false, undefined, undefined, undefined, undefined, false, 'IS NOT NULL'),
    HAS_MISSING_VALUE: registerFilterType('Has a missing value indicator', null, 'hasmvvalue'),
    DOES_NOT_HAVE_MISSING_VALUE: registerFilterType('Does not have a missing value indicator', null, 'nomvvalue'),
    Q: registerFilterType('Search', null, 'q', true, undefined, 'Search across all columns', undefined, undefined, true),
    ONTOLOGY_IN_SUBTREE: registerFilterType('Is In Subtree', null, 'concept:insubtree', true),
    ONTOLOGY_NOT_IN_SUBTREE: registerFilterType('Is Not In Subtree', null, 'concept:notinsubtree', true),
    EXP_CHILD_OF: registerFilterType('Is Child Of', null, 'exp:childof', true, undefined, ' is child of'),
    EXP_PARENT_OF: registerFilterType('Is Parent Of', null, 'exp:parentof', true, undefined, ' is parent of'),
    EXP_LINEAGE_OF: registerFilterType('In The Lineage Of', null, 'exp:lineageof', true, ',', ' in the lineage of'),
};
const TYPES_BY_JSON_TYPE = {
    boolean: [Types.HAS_ANY_VALUE, Types.EQUAL, Types.NEQ_OR_NULL, Types.ISBLANK, Types.NONBLANK],
    date: [
        Types.DATE_EQUAL,
        Types.DATE_NOT_EQUAL,
        Types.ISBLANK,
        Types.NONBLANK,
        Types.DATE_GREATER_THAN,
        Types.DATE_LESS_THAN,
        Types.DATE_GREATER_THAN_OR_EQUAL,
        Types.DATE_LESS_THAN_OR_EQUAL,
    ],
    time: [
        Types.EQUAL,
        Types.NEQ_OR_NULL,
        Types.ISBLANK,
        Types.NONBLANK,
        Types.GT,
        Types.LT,
        Types.GTE,
        Types.LTE,
        Types.BETWEEN,
        Types.NOT_BETWEEN,
    ],
    float: [
        Types.HAS_ANY_VALUE,
        Types.EQUAL,
        Types.NEQ_OR_NULL,
        Types.ISBLANK,
        Types.NONBLANK,
        Types.GT,
        Types.LT,
        Types.GTE,
        Types.LTE,
        Types.IN,
        Types.NOT_IN,
        Types.BETWEEN,
        Types.NOT_BETWEEN,
    ],
    int: [
        Types.HAS_ANY_VALUE,
        Types.EQUAL,
        Types.NEQ_OR_NULL,
        Types.ISBLANK,
        Types.NONBLANK,
        Types.GT,
        Types.LT,
        Types.GTE,
        Types.LTE,
        Types.IN,
        Types.NOT_IN,
        Types.BETWEEN,
        Types.NOT_BETWEEN,
    ],
    string: [
        Types.HAS_ANY_VALUE,
        Types.EQUAL,
        Types.NEQ_OR_NULL,
        Types.ISBLANK,
        Types.NONBLANK,
        Types.GT,
        Types.LT,
        Types.GTE,
        Types.LTE,
        Types.CONTAINS,
        Types.DOES_NOT_CONTAIN,
        Types.DOES_NOT_START_WITH,
        Types.STARTS_WITH,
        Types.IN,
        Types.NOT_IN,
        Types.CONTAINS_ONE_OF,
        Types.CONTAINS_NONE_OF,
        Types.BETWEEN,
        Types.NOT_BETWEEN,
    ],
};
const TYPES_BY_JSON_TYPE_DEFAULT = {
    boolean: Types.EQUAL,
    date: Types.DATE_EQUAL,
    float: Types.EQUAL,
    int: Types.EQUAL,
    string: Types.CONTAINS,
};
function _define(typeName, displayText, urlSuffix, isMultiType) {
    if (!Types[typeName]) {
        if (isMultiType) {
            Types[typeName] = registerFilterType(displayText, null, urlSuffix, true, ',');
        }
        else {
            Types[typeName] = registerFilterType(displayText, null, urlSuffix, true);
        }
    }
}
function getDefaultFilterForType(jsonType) {
    if (jsonType && TYPES_BY_JSON_TYPE_DEFAULT[jsonType.toLowerCase()]) {
        return TYPES_BY_JSON_TYPE_DEFAULT[jsonType.toLowerCase()];
    }
    return Types.EQUAL;
}
function getFilterTypeForURLSuffix(urlSuffix) {
    return urlMap[urlSuffix];
}
function getFilterTypesForType(jsonType, mvEnabled) {
    let types = [];
    if (jsonType && TYPES_BY_JSON_TYPE[jsonType.toLowerCase()]) {
        types = types.concat(TYPES_BY_JSON_TYPE[jsonType.toLowerCase()]);
    }
    if (mvEnabled) {
        types.push(Types.HAS_MISSING_VALUE);
        types.push(Types.DOES_NOT_HAVE_MISSING_VALUE);
    }
    return types;
}
function registerFilterType(displayText, displaySymbol, urlSuffix, dataValueRequired, multiValueSeparator, longDisplayText, minOccurs, maxOccurs, tableWise, labkeySqlOperator) {
    const isDataValueRequired = () => dataValueRequired === true;
    const isMultiValued = () => multiValueSeparator != null;
    const isTableWise = () => tableWise === true;
    const NEW_LINE_SEP = '\n';
    const type = {
        getDisplaySymbol: () => displaySymbol !== null && displaySymbol !== void 0 ? displaySymbol : null,
        getDisplayText: () => displayText,
        getLongDisplayText: () => longDisplayText || displayText,
        getURLSuffix: () => urlSuffix !== null && urlSuffix !== void 0 ? urlSuffix : null,
        isDataValueRequired,
        isMultiValued,
        isTableWise,
        getMultiValueFilter: () => (isMultiValued() ? null : urlMap[singleValueToMultiMap[urlSuffix]]),
        getMultiValueMaxOccurs: () => maxOccurs,
        getMultiValueMinOccurs: () => minOccurs,
        getMultiValueSeparator: () => multiValueSeparator !== null && multiValueSeparator !== void 0 ? multiValueSeparator : null,
        getOpposite: () => (oppositeMap[urlSuffix] ? urlMap[oppositeMap[urlSuffix]] : null),
        getSingleValueFilter: () => (isMultiValued() ? urlMap[multiValueToSingleMap[urlSuffix]] : urlMap[urlSuffix]),
        parseValue: value => {
            if (type.isMultiValued()) {
                if ((0,Utils.isString)(value)) {
                    if (value.indexOf('{json:') === 0 && value.indexOf('}') === value.length - 1) {
                        value = JSON.parse(value.substring('{json:'.length, value.length - 1));
                    }
                    else {
                        const regexPattern = new RegExp(`[${NEW_LINE_SEP}${type.getMultiValueSeparator()}]`);
                        value = value.split(regexPattern);
                    }
                }
                if (!(0,Utils.isArray)(value))
                    throw new Error("Filter '" +
                        type.getDisplayText() +
                        "' must be created with Array of values or a '" +
                        type.getMultiValueSeparator() +
                        "' separated string of values: " +
                        value);
            }
            if (!type.isMultiValued() && (0,Utils.isArray)(value))
                throw new Error("Array of values not supported for '" + type.getDisplayText() + "' filter: " + value);
            return value;
        },
        getURLParameterValue: (value) => {
            if (!type.isDataValueRequired()) {
                return '';
            }
            if (type.isMultiValued() && (0,Utils.isArray)(value)) {
                const sep = type.getMultiValueSeparator();
                const found = value.some((v) => {
                    return (0,Utils.isString)(v) && v.indexOf(sep) !== -1;
                });
                if (found) {
                    return '{json:' + JSON.stringify(value) + '}';
                }
                else {
                    return value.join(sep);
                }
            }
            return value;
        },
        validate: (value, jsonType, columnName) => {
            if (!isDataValueRequired()) {
                return true;
            }
            const f = TYPES_BY_JSON_TYPE[jsonType.toLowerCase()];
            let found = false;
            for (let i = 0; !found && i < f.length; i++) {
                if (f[i].getURLSuffix() == urlSuffix) {
                    found = true;
                }
            }
            if (!found) {
                alert("Filter type '" + displayText + "' can't be applied to " + type + ' types.');
                return undefined;
            }
            if (isMultiValued()) {
                return validateMultiple(type, jsonType, value, columnName, multiValueSeparator, minOccurs, maxOccurs);
            }
            else {
                return validate(jsonType, value, columnName);
            }
        },
        getLabKeySqlOperator: () => {
            return labkeySqlOperator;
        },
    };
    urlMap[urlSuffix] = type;
    return type;
}
function twoDigit(num) {
    if (num < 10) {
        return '0' + num;
    }
    return '' + num;
}
function validate(jsonType, value, columnName) {
    const strValue = value.toString();
    if (jsonType === 'boolean') {
        const upperVal = strValue.toUpperCase();
        if (upperVal == 'TRUE' ||
            upperVal == '1' ||
            upperVal == 'YES' ||
            upperVal == 'Y' ||
            upperVal == 'ON' ||
            upperVal == 'T') {
            return '1';
        }
        if (upperVal == 'FALSE' ||
            upperVal == '0' ||
            upperVal == 'NO' ||
            upperVal == 'N' ||
            upperVal == 'OFF' ||
            upperVal == 'F') {
            return '0';
        }
        else {
            alert(strValue +
                " is not a valid boolean for field '" +
                columnName +
                "'. Try true,false; yes,no; y,n; on,off; or 1,0.");
            return undefined;
        }
    }
    else if (jsonType === 'date') {
        let year, month, day, hour, minute;
        hour = 0;
        minute = 0;
        if (strValue.match(/^\s*(\d\d\d\d)-(\d\d)-(\d\d)\s*$/) ||
            strValue.match(/^\s*(\d\d\d\d)-(\d\d)-(\d\d)\s*(\d\d):(\d\d)\s*$/)) {
            return strValue;
        }
        else {
            const dateVal = new Date(strValue);
            if (isNaN(dateVal)) {
                if (strValue.match(/^(-|\+)/i)) {
                    return strValue;
                }
                alert(strValue + " is not a valid date for field '" + columnName + "'.");
                return undefined;
            }
            if (strValue.match(/\d+\/\d+\/\d{2}(\D|$)/)) {
                if (dateVal.getFullYear() < new Date().getFullYear() - 80)
                    dateVal.setFullYear(dateVal.getFullYear() + 100);
            }
            year = dateVal.getFullYear();
            month = dateVal.getMonth() + 1;
            day = dateVal.getDate();
            hour = dateVal.getHours();
            minute = dateVal.getMinutes();
        }
        let str = '' + year + '-' + twoDigit(month) + '-' + twoDigit(day);
        if (hour != 0 || minute != 0)
            str += ' ' + twoDigit(hour) + ':' + twoDigit(minute);
        return str;
    }
    else if (jsonType === 'float') {
        const decVal = parseFloat(strValue);
        if (isNaN(decVal)) {
            alert(strValue + " is not a valid decimal number for field '" + columnName + "'.");
            return undefined;
        }
        else {
            return '' + decVal;
        }
    }
    else if (jsonType === 'int') {
        const intVal = parseInt(strValue);
        if (isNaN(intVal)) {
            alert(strValue + " is not a valid integer for field '" + columnName + "'.");
            return undefined;
        }
        else {
            return '' + intVal;
        }
    }
    else {
        return strValue;
    }
}
function validateMultiple(filterType, jsonType, value, columnName, sep, minOccurs, maxOccurs) {
    let values;
    try {
        values = filterType.parseValue(value);
    }
    catch (x) {
        alert('Failed to validate filter: ' + x.toString());
        return undefined;
    }
    const result = [];
    for (let i = 0; i < values.length; i++) {
        const valid = validate(jsonType, values[i].trim(), columnName);
        if (valid == undefined) {
            return undefined;
        }
        result.push(valid);
    }
    if (minOccurs !== undefined && minOccurs > 0) {
        if (values.length < minOccurs) {
            alert('At least ' + minOccurs + " '" + sep + "' separated values are required");
            return undefined;
        }
    }
    if (maxOccurs !== undefined && maxOccurs > 0) {
        if (values.length > maxOccurs) {
            alert('At most ' + maxOccurs + " '" + sep + "' separated values are allowed");
            return undefined;
        }
    }
    return filterType.getURLParameterValue(values);
}

;// CONCATENATED MODULE: ./src/labkey/filter/Filter.ts




class Filter {
    constructor(columnName, value, filterType) {
        if (columnName) {
            if (columnName instanceof FieldKey/* FieldKey */.W) {
                columnName = columnName.toString();
            }
            else if (columnName instanceof Array) {
                columnName = columnName.join('/');
            }
        }
        if (!filterType) {
            filterType = Types.EQUAL;
        }
        if (filterType.isTableWise()) {
            columnName = '*';
        }
        if (value) {
            value = filterType.parseValue(value);
        }
        this.columnName = columnName;
        this.filterType = filterType;
        this.value = value;
    }
    getColumnName() {
        return this.columnName;
    }
    getFilterType() {
        return this.filterType;
    }
    getURLParameterName(dataRegionName) {
        return [(0,Utils.ensureRegionName)(dataRegionName), '.', this.columnName, '~', this.filterType.getURLSuffix()].join('');
    }
    getURLParameterValue() {
        return this.filterType.getURLParameterValue(this.value);
    }
    getValue() {
        return this.value;
    }
}
function appendAggregateParams(params, aggregates, dataRegionName) {
    const prefix = (0,Utils.ensureRegionName)(dataRegionName) + '.agg.';
    const _params = params || {};
    if ((0,Utils.isArray)(aggregates)) {
        for (let i = 0; i < aggregates.length; i++) {
            const aggregate = aggregates[i];
            let value = 'type=' + aggregate.type;
            if (aggregate.label) {
                value = value + '&label=' + aggregate.label;
            }
            if (aggregate.type && aggregate.column) {
                const paramName = prefix + aggregate.column;
                let paramValue = encodeURIComponent(value);
                if (_params[paramName] !== undefined) {
                    let values = _params[paramName];
                    if (!(0,Utils.isArray)(values)) {
                        values = [values];
                    }
                    values.push(paramValue);
                    paramValue = values;
                }
                _params[paramName] = paramValue;
            }
        }
    }
    return _params;
}
function appendFilterParams(params, filterArray, dataRegionName) {
    const regionName = (0,Utils.ensureRegionName)(dataRegionName);
    const filterParams = params || {};
    if (filterArray) {
        for (let i = 0; i < filterArray.length; i++) {
            const filter = filterArray[i];
            if (filter.getFilterType().isDataValueRequired() && filter.getURLParameterValue() == null) {
                continue;
            }
            const name = filter.getURLParameterName(regionName);
            let value = filter.getURLParameterValue();
            if (filterParams[name] !== undefined) {
                let values = filterParams[name];
                if (!(0,Utils.isArray)(values)) {
                    values = [values];
                }
                values.push(value);
                value = values;
            }
            filterParams[name] = value;
        }
    }
    return filterParams;
}
function create(column, value, type) {
    return new Filter(column, value, type);
}
function getFilterDescription(url, dataRegionName, columnName) {
    const params = (0,ActionURL.getParameters)(url);
    let result = '';
    let sep = '';
    for (const paramName in params) {
        if (params.hasOwnProperty(paramName)) {
            if (paramName.indexOf(dataRegionName + '.' + columnName + '~') == 0) {
                const filterType = paramName.substring(paramName.indexOf('~') + 1);
                let values = params[paramName];
                if (!(0,Utils.isArray)(values)) {
                    values = [values];
                }
                const friendly = getFilterTypeForURLSuffix(filterType);
                let displayText;
                if (friendly) {
                    displayText = friendly.getDisplayText();
                }
                else {
                    displayText = filterType;
                }
                for (let i = 0; i < values.length; i++) {
                    result += sep + displayText + ' ' + values[i];
                    sep = ' AND ';
                }
            }
        }
    }
    return result;
}
function getFiltersFromParameters(params, dataRegionName) {
    const filters = [];
    const regionName = (0,Utils.ensureRegionName)(dataRegionName);
    Object.keys(params).forEach(paramName => {
        if (paramName.indexOf(regionName + '.') == 0) {
            const tilde = paramName.indexOf('~');
            if (tilde != -1) {
                const columnName = paramName.substring(regionName.length + 1, tilde);
                const filterName = paramName.substring(tilde + 1);
                const filterType = getFilterTypeForURLSuffix(filterName);
                const values = params[paramName];
                if ((0,Utils.isArray)(values)) {
                    for (let i = 0; i < values.length; i++) {
                        filters.push(create(columnName, values[i], filterType));
                    }
                }
                else {
                    filters.push(create(columnName, values, filterType));
                }
            }
        }
    });
    return filters;
}
function getFiltersFromUrl(url, dataRegionName) {
    return getFiltersFromParameters((0,ActionURL.getParameters)(url), dataRegionName);
}
function getQueryParamsFromUrl(url, dataRegionName) {
    const queryParams = {};
    const params = (0,ActionURL.getParameters)(url);
    const key = (0,Utils.ensureRegionName)(dataRegionName) + '.param.';
    for (const paramName in params) {
        if (params.hasOwnProperty(paramName)) {
            if (paramName.indexOf(key) == 0) {
                const qParamName = paramName.substring(key.length);
                queryParams[qParamName] = params[paramName];
            }
        }
    }
    return queryParams;
}
function getSortFromUrl(url, dataRegionName) {
    const regionName = (0,Utils.ensureRegionName)(dataRegionName);
    const params = (0,ActionURL.getParameters)(url);
    return params[regionName + '.sort'];
}
function merge(baseFilters, columnName, columnFilters) {
    const newFilters = [];
    if (baseFilters && baseFilters.length > 0) {
        for (let i = 0; i < baseFilters.length; i++) {
            const bi = baseFilters[i];
            if (bi.getColumnName() != columnName) {
                newFilters.push(bi);
            }
        }
    }
    return columnFilters && columnFilters.length > 0 ? newFilters.concat(columnFilters) : newFilters;
}

;// CONCATENATED MODULE: ./src/labkey/Assay.ts




function applyArguments(args, options, parameter) {
    let _options;
    if (args.length > 1) {
        _options = {
            success: args[0],
            failure: args[1],
            parameters: parameter ? { [parameter]: args[2] } : {},
            containerPath: parameter ? args[3] : args[2],
        };
    }
    else {
        _options = options;
    }
    return _options;
}
var AssayLink;
(function (AssayLink) {
    AssayLink["BATCHES"] = "batches";
    AssayLink["BEGIN"] = "begin";
    AssayLink["DESIGN_COPY"] = "designCopy";
    AssayLink["DESIGN_EDIT"] = "designEdit";
    AssayLink["IMPORT"] = "import";
    AssayLink["RESULT"] = "result";
    AssayLink["RESULTS"] = "results";
    AssayLink["RUNS"] = "runs";
})(AssayLink || (AssayLink = {}));
function getAssays(options) {
    moveParameters(options, 'id', 'name', 'plateEnabled', 'status', 'type');
    return request({
        url: (0,ActionURL.buildURL)('assay', 'assayList.api', options.containerPath),
        method: 'POST',
        jsonData: options.parameters,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope, false, data => data.definitions),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
        scope: options.scope || this,
    });
}
function getAll(options) {
    return getAssays(applyArguments(arguments, options));
}
function getById(options) {
    return getAssays(applyArguments(arguments, options, 'id'));
}
function getByName(options) {
    return getAssays(applyArguments(arguments, options, 'name'));
}
function getByType(options) {
    return getAssays(applyArguments(arguments, options, 'type'));
}
function getNAbRuns(options) {
    const params = (0,Utils.merge)({}, options);
    if (options.sort) {
        params['query.sort'] = options.sort;
    }
    if (options.offset) {
        params['query.offset'] = options.offset;
    }
    if (options.maxRows) {
        if (options.maxRows < 0) {
            params['query.showRows'] = 'all';
        }
        else {
            params['query.maxRows'] = options.maxRows;
        }
    }
    return request({
        url: (0,ActionURL.buildURL)('nabassay', 'getNabRuns.api', options.containerPath),
        params: appendFilterParams(params, options.filterArray),
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope, false, data => data.runs),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
        timeout: options.timeout,
    });
}
function getStudyNabGraphURL(options) {
    const params = {};
    (0,Utils.applyTranslated)(params, options, { objectIds: 'id' }, true, false);
    return request({
        url: (0,ActionURL.buildURL)('nabassay', 'getStudyNabGraphURL.api', options.containerPath),
        params,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options) || Utils.displayAjaxErrorResponse, options.scope, true),
        timeout: options.timeout,
    });
}
function getStudyNabRuns(options) {
    return request({
        url: (0,ActionURL.buildURL)('nabassay', 'getStudyNabRuns.api', options.containerPath),
        params: (0,Utils.merge)({}, options),
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope, false, data => data.runs),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options) || Utils.displayAjaxErrorResponse, options.scope, true),
        timeout: options.timeout,
    });
}
function moveParameters(config, ...params) {
    if (!config.parameters) {
        config.parameters = {};
    }
    for (let i = 0; i < params.length; i++) {
        const param = params[i];
        if (config.hasOwnProperty(param)) {
            config.parameters[param] = config[param];
            delete config[param];
        }
    }
}

;// CONCATENATED MODULE: ./src/labkey/Domain.ts



function Domain_create(config) {
    const options = arguments.length > 1 ? mapCreateArguments(arguments) : config;
    return request({
        url: (0,ActionURL.buildURL)('property', 'createDomain.api', options.containerPath),
        method: 'POST',
        jsonData: options,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), config.scope, true),
    });
}
function mapCreateArguments(args) {
    const options = {
        failure: args[1],
        success: args[0],
    };
    if ((args.length === 4 || args.length === 5) && (0,Utils.isString)(args[3])) {
        options.containerPath = args[4];
        options.domainGroup = args[2];
        options.domainTemplate = args[3];
    }
    else {
        options.containerPath = args[5];
        options.domainDesign = args[3];
        options.kind = args[2];
        options.options = args[4];
    }
    return options;
}
function drop(config) {
    return request({
        url: (0,ActionURL.buildURL)('property', 'deleteDomain.api', config.containerPath),
        method: 'POST',
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
        jsonData: {
            domainDesign: config.domainDesign,
            schemaName: config.schemaName,
            queryName: config.queryName,
        },
    });
}
function getDomainDetails(config) {
    const options = arguments.length > 1
        ? {
            containerPath: arguments[4],
            failure: arguments[1],
            queryName: arguments[3],
            schemaName: arguments[2],
            success: arguments[0],
        }
        : config;
    return request({
        url: (0,ActionURL.buildURL)('property', 'getDomainDetails.api', options.containerPath),
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
        params: {
            schemaName: options.schemaName,
            queryName: options.queryName,
            domainId: options.domainId,
            domainKind: options.domainKind,
        },
    });
}
function get(config) {
    const options = arguments.length > 1
        ? {
            containerPath: arguments[4],
            failure: arguments[1],
            queryName: arguments[3],
            schemaName: arguments[2],
            success: arguments[0],
        }
        : config;
    return request({
        url: (0,ActionURL.buildURL)('property', 'getDomain.api', options.containerPath),
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
        params: {
            schemaName: options.schemaName,
            queryName: options.queryName,
            domainId: options.domainId,
        },
    });
}
function save(config) {
    const options = arguments.length > 1
        ? {
            success: arguments[0],
            failure: arguments[1],
            domainDesign: arguments[2],
            schemaName: arguments[3],
            queryName: arguments[4],
            containerPath: arguments[5],
            includeWarnings: arguments[6],
            options: arguments[7],
        }
        : config;
    return request({
        url: (0,ActionURL.buildURL)('property', 'saveDomain.api', options.containerPath),
        method: 'POST',
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
        jsonData: {
            domainDesign: options.domainDesign,
            schemaName: options.schemaName,
            queryName: options.queryName,
            domainId: options.domainId,
            includeWarnings: options.includeWarnings,
            options: options.options,
        },
    });
}
function validateNameExpressions(config) {
    return request({
        url: (0,ActionURL.buildURL)('property', 'validateNameExpressions.api', config.containerPath),
        method: 'POST',
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
        jsonData: {
            domainDesign: config.domainDesign,
            options: config.options,
            kind: config.kind,
        },
    });
}
function getDomainNamePreviews(config) {
    return request({
        url: (0,ActionURL.buildURL)('property', 'getDomainNamePreviews.api', config.containerPath),
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
        params: {
            schemaName: config.schemaName,
            queryName: config.queryName,
            domainId: config.domainId,
        },
    });
}
function updateDomain(config) {
    const params = {
        domainId: config.domainId,
        includeWarnings: config.includeWarnings,
    };
    if (config.createFields)
        params.createFields = config.createFields;
    if (config.updateFields)
        params.updateFields = config.updateFields;
    if (config.deleteFields)
        params.deleteFields = config.deleteFields;
    return request({
        url: (0,ActionURL.buildURL)('property', 'updateDomain.api', config.containerPath),
        method: 'POST',
        jsonData: params,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function listDomains(config) {
    const params = {};
    if (config.domainKinds)
        params.domainKinds = config.domainKinds;
    if (config.includeFields !== undefined)
        params.includeFields = config.includeFields;
    if (config.includeProjectAndShared !== undefined)
        params.includeProjectAndShared = config.includeProjectAndShared;
    return request({
        url: (0,ActionURL.buildURL)('property', 'listDomains.api', config.containerPath),
        params,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function getProperties(config) {
    const params = {};
    if (config.domainIds)
        params.domainIds = config.domainIds;
    if (config.domainKinds)
        params.domainKinds = config.domainKinds;
    if (config.filters) {
        params.filters = config.filters.map(f => f.getURLParameterName('query') + '=' + f.getURLParameterValue());
    }
    if (config.maxRows !== undefined)
        params.maxRows = config.maxRows;
    if (config.offset !== undefined)
        params.offset = config.offset;
    if (config.propertyIds)
        params.propertyIds = config.propertyIds;
    if (config.propertyURIs)
        params.propertyURIs = config.propertyURIs;
    if (config.search)
        params.search = config.search;
    if (config.sort)
        params.sort = config.sort;
    return request({
        url: (0,ActionURL.buildURL)('property', 'getProperties.api', config.containerPath),
        method: 'POST',
        jsonData: params,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function getPropertyUsages(config) {
    const params = {};
    if (config.maxUsageCount !== undefined)
        params.maxUsageCount = config.maxUsageCount;
    if (config.propertyIds)
        params.propertyIds = config.propertyIds;
    if (config.propertyURIs)
        params.propertyURIs = config.propertyURIs;
    return request({
        url: (0,ActionURL.buildURL)('property', 'propertyUsages.api', config.containerPath),
        params,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope, false, (json) => json.data),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
var KINDS;
(function (KINDS) {
    KINDS["DATA_CLASS"] = "DataClass";
    KINDS["INT_LIST"] = "IntList";
    KINDS["SAMPLE_TYPE"] = "SampleSet";
    KINDS["STUDY_DATASET_DATE"] = "StudyDatasetDate";
    KINDS["STUDY_DATASET_VISIT"] = "StudyDatasetVisit";
    KINDS["UNKNOWN"] = "Unknown";
    KINDS["VAR_LIST"] = "VarList";
})(KINDS || (KINDS = {}));

;// CONCATENATED MODULE: ./src/labkey/Exp.ts




class ExpObject {
    constructor(config = {}) {
        this.lsid = config.lsid;
        this.name = config.name;
        this.id = config.id || config.rowId;
        this.rowId = this.id;
        this.comment = config.comment;
        this.created = config.created;
        this.createdBy = config.createdBy;
        this.modified = config.modified;
        this.modifiedBy = config.modifiedBy;
        this.properties = config.properties || {};
    }
}
class DataClass extends ExpObject {
    constructor(config = {}) {
        super(config);
        config = config || {};
        this.description = config.description;
        this.sampleSet = config.sampleSet;
    }
    static create(options) {
        Domain_create({
            containerPath: options.containerPath,
            domainDesign: options.domainDesign,
            kind: 'DataClass',
            options: options.options,
            success: (0,Utils.getOnSuccess)(options),
            failure: (0,Utils.getOnFailure)(options),
        });
    }
    getDomainDetails(options) {
        getDomainDetails({
            schemaName: 'exp.data',
            queryName: this.name,
            containerPath: options.containerPath,
            success: (0,Utils.getOnSuccess)(options),
            failure: (0,Utils.getOnFailure)(options),
        });
    }
}
class ChildObject extends ExpObject {
    constructor(config = {}) {
        super(config);
    }
}
class ProtocolApplication extends ExpObject {
    constructor(config = {}) {
        super(config);
    }
}
class RunItem extends ExpObject {
    constructor(config = {}) {
        super(config);
        this.cpasType = config.cpasType;
        this.run = config.run;
        this.sourceApplications = config.sourceApplications;
        this.sourceProtocol = config.sourceProtocol;
        this.sucessorRuns = config.sucessorRuns;
        this.targetApplications = config.targetApplications;
    }
}
class Data extends ExpObject {
    constructor(config = {}) {
        super(config);
        this.dataType = config.dataType;
        this.dataFileURL = config.dataFileURL;
        this.dataClass = config.dataClass;
        if (config.pipelinePath) {
            this.pipelinePath = config.pipelinePath;
        }
        if (config.role) {
            this.role = config.role;
        }
    }
    getContent(options) {
        function getSuccessCallbackWrapper(success, format, scope) {
            return (0,Utils.getCallbackWrapper)(function (json, response) {
                if (success) {
                    success.call(scope || this, json, format, response);
                }
            });
        }
        request({
            url: (0,ActionURL.buildURL)('experiment', 'showFile'),
            method: 'GET',
            params: {
                format: options.format,
                rowId: this.id,
            },
            success: getSuccessCallbackWrapper((0,Utils.getOnSuccess)(options), options.format, options.scope),
            failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
        });
    }
}
class Run extends ExpObject {
    constructor(config = {}) {
        super(config);
        this.experiments = config.experiments || [];
        this.protocol = config.protocol;
        this.filePathRoot = config.filePathRoot;
        this.dataInputs = [];
        if (config.dataInputs) {
            for (let i = 0; i < config.dataInputs.length; i++) {
                this.dataInputs.push(new Data(config.dataInputs[i]));
            }
        }
        this.dataOutputs = config.dataOutputs || [];
        this.dataRows = config.dataRows || [];
        this.materialInputs = config.materialInputs || [];
        this.materialOutputs = config.materialOutputs || [];
        this.objectProperties = config.objectProperties || {};
    }
    deleteRun(options) {
        return request({
            url: (0,ActionURL.buildURL)('experiment', 'deleteRun.api'),
            method: 'POST',
            params: {
                runId: this.id,
            },
            success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), this),
            failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), this, true),
        });
    }
}
class RunGroup extends ExpObject {
    constructor(config = {}) {
        super(config);
        this.batchProtocolId = config.batchProtocolId || 0;
        this.hidden = config.hidden;
        this.runs = [];
        if (config.runs) {
            for (let i = 0; i < config.runs.length; i++) {
                this.runs.push(new Run(config.runs[i]));
            }
        }
    }
}
class Material extends RunItem {
    constructor(config = {}) {
        super(config);
        this.sampleSet = config.sampleSet;
    }
}
class Protocol extends ExpObject {
    constructor(config = {}) {
        super(config);
        this.applicationType = config.applicationType;
        this.childProtocols = config.childProtocols || [];
        this.contact = config.contact;
        this.description = config.description;
        this.instrument = config.instrument;
        this.runs = [];
        this.software = config.software;
        this.steps = config.steps || [];
        if (config.runs) {
            for (let i = 0; i < config.runs.length; i++) {
                this.runs.push(new Run(config.runs[i]));
            }
        }
    }
}
class SampleSet extends ExpObject {
    constructor(config = {}) {
        super(config);
        this.description = config.description;
        this.samples = config.samples;
    }
    static create(options) {
        Domain_create({
            containerPath: options.containerPath,
            domainDesign: options.domainDesign,
            kind: KINDS.SAMPLE_TYPE,
            options: options.options,
            success: (0,Utils.getOnSuccess)(options),
            failure: (0,Utils.getOnFailure)(options),
        });
    }
    getDomainDetails(options) {
        getDomainDetails({
            schemaName: 'Samples',
            queryName: this.name,
            containerPath: options.containerPath,
            success: (0,Utils.getOnSuccess)(options),
            failure: (0,Utils.getOnFailure)(options),
        });
    }
}

;// CONCATENATED MODULE: ./src/labkey/query/Rows.ts



function Rows_applyArguments(options, args, action) {
    return args && args.length > 1
        ? Object.assign(Object.assign({}, queryArguments(args)), { action }) : Object.assign(Object.assign({}, options), { action });
}
function deleteRows(options) {
    return sendRequest(Rows_applyArguments(options, arguments, 'deleteRows.api'));
}
function insertRows(options) {
    return sendRequest(Rows_applyArguments(options, arguments, 'insertRows.api'), true);
}
function queryArguments(args) {
    return {
        schemaName: args[0],
        queryName: args[1],
        rows: args[2],
        success: args[3],
        failure: args[4],
    };
}
function saveRows(options) {
    return request({
        url: (0,ActionURL.buildURL)('query', 'saveRows.api', options.containerPath),
        method: 'POST',
        jsonData: {
            apiVersion: options.apiVersion,
            commands: options.commands,
            containerPath: options.containerPath,
            extraContext: options.extraContext,
            transacted: options.transacted,
            validateOnly: options.validateOnly,
        },
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
        timeout: options.timeout,
    });
}
function bindFormData(jsonData, options, supportsFiles = false) {
    var _a;
    let form;
    if (options.form instanceof FormData) {
        if (!options.form.has('json')) {
            options.form.append('json', JSON.stringify(jsonData));
        }
        form = options.form;
    }
    else if (supportsFiles && options.autoFormFileData) {
        const hasFileData = (_a = jsonData.rows) === null || _a === void 0 ? void 0 : _a.find(row => {
            return !!row && Object.values(row).find(value => value instanceof File);
        });
        if (hasFileData) {
            form = new FormData();
            const rows = [];
            jsonData.rows.forEach((row, i) => {
                if (row) {
                    const _row = {};
                    Object.keys(row).forEach(k => {
                        if (row[k] instanceof File) {
                            form.append(`${k}::${i}`, row[k]);
                        }
                        else {
                            _row[k] = row[k];
                        }
                    });
                    rows.push(_row);
                }
                else {
                    rows.push(row);
                }
            });
            form.append('json', JSON.stringify(Object.assign(Object.assign({}, jsonData), { rows })));
        }
    }
    return form;
}
function sendRequest(options, supportsFiles) {
    const jsonData = {
        schemaName: options.schemaName,
        queryName: options.queryName,
        rows: options.rows || options.rowDataArray,
        transacted: options.transacted,
        extraContext: options.extraContext,
        auditBehavior: options.auditBehavior,
        auditUserComment: options.auditUserComment,
        skipReselectRows: options.skipReselectRows,
    };
    const form = bindFormData(jsonData, options, supportsFiles);
    return request(Object.assign(Object.assign({ url: (0,ActionURL.buildURL)('query', options.action, options.containerPath), method: 'POST', success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope), failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true) }, (form ? { form } : { jsonData })), { timeout: options.timeout }));
}
function truncateTable(options) {
    return sendRequest(Rows_applyArguments(options, undefined, 'truncateTable.api'));
}
function updateRows(options) {
    return sendRequest(Rows_applyArguments(options, arguments, 'updateRows.api'), true);
}
function moveRows(options) {
    const jsonData = {
        targetContainerPath: options.targetContainerPath,
        schemaName: options.schemaName,
        queryName: options.queryName,
        rows: options.rows,
        auditBehavior: options.auditBehavior,
        auditUserComment: options.auditUserComment,
        dataRegionSelectionKey: options.dataRegionSelectionKey,
        useSnapshotSelection: options.useSnapshotSelection,
        extraContext: options.extraContext,
    };
    return request({
        url: (0,ActionURL.buildURL)('query', 'moveRows.api', options.containerPath),
        method: 'POST',
        jsonData,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
        timeout: options.timeout,
    });
}

;// CONCATENATED MODULE: ./src/labkey/Experiment.ts





const SAMPLE_DERIVATION_PROTOCOL = 'Sample Derivation Protocol';
const SAMPLE_ALIQUOT_PROTOCOL = 'Sample Aliquot Protocol';
function applyExperimentJSONConverterOptions(options) {
    const params = {};
    if (options.includeInputsAndOutputs !== undefined) {
        params.includeInputsAndOutputs = options.includeInputsAndOutputs;
    }
    if (options.includeProperties !== undefined) {
        params.includeProperties = options.includeProperties;
    }
    if (options.includeRunSteps !== undefined) {
        params.includeRunSteps = options.includeRunSteps;
    }
    return params;
}
function createHiddenRunGroup(options) {
    const jsonData = {};
    if (options.runIds && options.selectionKey) {
        throw 'Only one of runIds or selectionKey config parameter is allowed for a single call.';
    }
    else if (options.runIds) {
        jsonData.runIds = options.runIds;
    }
    else if (options.selectionKey) {
        jsonData.selectionKey = options.selectionKey;
    }
    else {
        throw 'Either the runIds or the selectionKey config parameter is required';
    }
    return request({
        url: (0,ActionURL.buildURL)('experiment', 'createHiddenRunGroup.api', options.containerPath),
        method: 'POST',
        jsonData,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope, false, json => new RunGroup(json)),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
    });
}
function createRunGroups(json) {
    const batches = [];
    if (json.batches) {
        for (let i = 0; i < json.batches.length; i++) {
            batches.push(new RunGroup(json.batches[i]));
        }
    }
    return batches;
}
function createRuns(json) {
    const runs = [];
    if (json.runs) {
        for (let i = 0; i < json.runs.length; i++) {
            runs.push(new Run(json.runs[i]));
        }
    }
    return runs;
}
function exportRuns(config) {
    throw new Error('dom/Experiment.js required');
}
function lineage(options) {
    const params = Object.assign({}, applyExperimentJSONConverterOptions(options));
    if (options.lsids) {
        params.lsids = options.lsids;
    }
    else if (options.lsid) {
        params.lsid = options.lsid;
    }
    if (options.hasOwnProperty('parents')) {
        params.parents = options.parents;
    }
    if (options.hasOwnProperty('children')) {
        params.children = options.children;
    }
    if (options.hasOwnProperty('depth')) {
        params.depth = options.depth;
    }
    if (options.expType) {
        params.expType = options.expType;
    }
    if (options.cpasType) {
        params.cpasType = options.cpasType;
    }
    if (options.runProtocolLsid) {
        params.runProtocolLsid = options.runProtocolLsid;
    }
    return request({
        url: (0,ActionURL.buildURL)('experiment', 'lineage.api', options.containerPath),
        params,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
    });
}
function loadBatch(options) {
    return request({
        url: (0,ActionURL.buildURL)('assay', 'getAssayBatch.api', options.containerPath),
        method: 'POST',
        jsonData: {
            assayId: options.assayId,
            assayName: options.assayName,
            batchId: options.batchId,
            protocolName: options.protocolName,
            providerName: options.providerName,
        },
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope, false, (json) => new RunGroup(json.batch)),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
    });
}
function loadBatches(options) {
    return request({
        url: (0,ActionURL.buildURL)('assay', 'getAssayBatches.api', options.containerPath),
        method: 'POST',
        jsonData: {
            assayId: options.assayId,
            assayName: options.assayName,
            batchIds: options.batchIds,
            protocolName: options.protocolName,
            providerName: options.providerName,
        },
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope, false, createRunGroups),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
    });
}
function loadRuns(options) {
    const jsonData = Object.assign({}, applyExperimentJSONConverterOptions(options));
    if (options.runIds) {
        jsonData.runIds = options.runIds;
    }
    if (options.lsids) {
        jsonData.lsids = options.lsids;
    }
    return request({
        url: (0,ActionURL.buildURL)('assay', 'getAssayRuns.api', options.containerPath),
        method: 'POST',
        jsonData,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope, false, createRuns),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
    });
}
function resolve(options) {
    const params = Object.assign({}, applyExperimentJSONConverterOptions(options));
    if (options.lsids) {
        params.lsids = options.lsids;
    }
    return request({
        url: (0,ActionURL.buildURL)('experiment', 'resolve.api', options.containerPath),
        params,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
    });
}
function requestSaveBatches(rawOptions, payloadProcessor) {
    return request({
        url: (0,ActionURL.buildURL)('assay', 'saveAssayBatch.api', rawOptions.containerPath),
        method: 'POST',
        jsonData: {
            assayId: rawOptions.assayId,
            assayName: rawOptions.assayName,
            batches: rawOptions.batches ? rawOptions.batches : [rawOptions.batch],
            protocolName: rawOptions.protocolName,
            providerName: rawOptions.providerName,
        },
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(rawOptions), rawOptions.scope, false, payloadProcessor),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(rawOptions), rawOptions.scope, true),
    });
}
function saveBatch(options) {
    return requestSaveBatches(options, (json) => {
        if (json.batches) {
            return new RunGroup(json.batches[0]);
        }
    });
}
function saveBatches(options) {
    return requestSaveBatches(options, createRunGroups);
}
function saveMaterials(options) {
    return insertRows({
        schemaName: 'Samples',
        queryName: options.name,
        rows: options.materials,
        success: (0,Utils.getOnSuccess)(options),
        failure: (0,Utils.getOnFailure)(options),
        scope: options.scope,
    });
}
function saveRuns(options) {
    return request({
        url: (0,ActionURL.buildURL)('assay', 'saveAssayRuns.api', options.containerPath),
        method: 'POST',
        jsonData: {
            assayId: options.assayId,
            assayName: options.assayName,
            protocolName: options.protocolName,
            providerName: options.providerName,
            runs: options.runs,
        },
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope, false, createRuns),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
    });
}
function setEntitySequence(config) {
    return request({
        url: (0,ActionURL.buildURL)('experiment', 'setEntitySequence.api', config.containerPath),
        method: 'POST',
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
        jsonData: {
            rowId: config.rowId,
            kindName: config.kindName,
            newValue: config.newValue,
            seqType: config.seqType,
        },
    });
}
function getEntitySequence(config) {
    return request({
        url: (0,ActionURL.buildURL)('experiment', 'getEntitySequence.api', config.containerPath),
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
        params: {
            rowId: config.rowId,
            kindName: config.kindName,
            seqType: config.seqType,
        },
    });
}

;// CONCATENATED MODULE: ./src/labkey/Filter.ts




;// CONCATENATED MODULE: ./src/labkey/List.ts
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

function List_create(config) {
    var _a;
    const { keyName, keyType } = config, options = __rest(config, ["keyName", "keyType"]);
    const { description, fields, indices, name } = options, createDomainOptions = __rest(options, ["description", "fields", "indices", "name"]);
    const domainOptions = Object.assign(Object.assign({}, createDomainOptions), { options: (_a = createDomainOptions.options) !== null && _a !== void 0 ? _a : {} });
    if (!domainOptions.domainDesign) {
        domainOptions.domainDesign = { description, fields, indices, name };
    }
    if (!domainOptions.domainDesign.name) {
        throw new Error('List name required');
    }
    if (!domainOptions.kind) {
        if (keyType === 'int' || keyType === 'IntList') {
            domainOptions.kind = 'IntList';
        }
        else if (keyType === 'string' || keyType === 'VarList') {
            domainOptions.kind = 'VarList';
            domainOptions.options.keyType = 'Varchar';
        }
        else if (keyType === 'AutoIncrementInteger') {
            domainOptions.kind = 'IntList';
            domainOptions.options.keyType = 'AutoIncrementInteger';
        }
        else {
            throw new Error('List kind or keyType required');
        }
    }
    if (!domainOptions.options.keyName) {
        if (keyName) {
            domainOptions.options.keyName = keyName;
        }
        else {
            throw new Error('List keyName or options.keyName required');
        }
    }
    Domain_create(domainOptions);
}

;// CONCATENATED MODULE: ./src/labkey/MultiRequest.ts

const MultiRequest = function (config) {
    const doneCallbacks = [];
    const self = this;
    let sending = false;
    let sendQ = [];
    let waitQ = [];
    function applyCallback(callback, scope) {
        if (typeof callback === 'function') {
            doneCallbacks.push({
                fn: callback,
                scope,
            });
        }
        else if (callback && typeof callback.fn === 'function') {
            doneCallbacks.push({
                fn: callback.fn,
                scope: callback.scope || scope,
            });
        }
    }
    function checkDone() {
        sendQ.pop();
        if (sendQ.length == 0) {
            sending = false;
            fireDone();
            self.send();
        }
        return true;
    }
    function createSequence(fn1, fn2, scope) {
        return function () {
            const ret = fn1.apply(scope || this || window, arguments);
            fn2.apply(scope || this || window, arguments);
            return ret;
        };
    }
    function fireDone() {
        for (let i = 0; i < doneCallbacks.length; i++) {
            const cb = doneCallbacks[i];
            if (cb.fn && typeof cb.fn === 'function') {
                cb.fn.call(cb.scope || window);
            }
        }
    }
    this.add = function (fn, config, scope) {
        config = config || {};
        let success = (0,Utils.getOnSuccess)(config);
        if (!success) {
            success = function () { };
        }
        if (!success._hookInstalled) {
            config.success = createSequence(success, checkDone, config.scope);
            config.success._hookInstalled = true;
        }
        let failure = (0,Utils.getOnFailure)(config);
        if (!failure) {
            failure = function () { };
        }
        if (!failure._hookInstalled) {
            config.failure = createSequence(failure, checkDone, config.scope);
            config.failure._hookInstalled = true;
        }
        waitQ.push({
            args: [config],
            fn,
            scope,
        });
        return this;
    };
    this.send = function (callback, scope) {
        if (sending || waitQ.length === 0) {
            return;
        }
        sending = true;
        sendQ = waitQ;
        waitQ = [];
        const len = sendQ.length;
        for (let i = 0; i < len; i++) {
            const q = sendQ[i];
            q.fn.apply(q.scope || window, q.args);
        }
        applyCallback(callback, scope);
    };
    const cfg = config || {};
    let listeners;
    let requests;
    if ((0,Utils.isArray)(cfg)) {
        requests = cfg;
    }
    else {
        requests = cfg.requests;
        listeners = cfg.listeners;
    }
    if (requests) {
        for (let i = 0; i < requests.length; i++) {
            const request = requests[i];
            this.add(request[0], request[1]);
        }
    }
    if (listeners && listeners.done) {
        applyCallback(listeners.done, listeners.scope);
    }
    if (waitQ.length && doneCallbacks.length > 0) {
        this.send();
    }
    return this;
};

;// CONCATENATED MODULE: ./src/labkey/Message.ts



function createMsgContent(type, content) {
    return {
        content,
        type,
    };
}
function createPrincipalIdRecipient(type, principalId) {
    return {
        principalId,
        type,
    };
}
function createRecipient(type, address) {
    return {
        address,
        type,
    };
}
const msgType = {
    html: 'text/html',
    plain: 'text/plain',
};
const recipientType = {
    bcc: 'BCC',
    cc: 'CC',
    to: 'TO',
};
function sendMessage(config) {
    const jsonData = {};
    if (config.msgFrom != undefined) {
        jsonData.msgFrom = config.msgFrom;
    }
    if (config.msgRecipients != undefined) {
        jsonData.msgRecipients = config.msgRecipients;
    }
    if (config.msgContent != undefined) {
        jsonData.msgContent = config.msgContent;
    }
    if (config.msgSubject != undefined) {
        jsonData.msgSubject = config.msgSubject;
    }
    return request({
        url: (0,ActionURL.buildURL)('announcements', 'sendMessage.api'),
        method: 'POST',
        jsonData,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}

;// CONCATENATED MODULE: ./src/labkey/ParticipantGroup.ts



function updateParticipantGroup(options) {
    const jsonData = {
        rowId: options.rowId,
    };
    if (options.participantIds) {
        jsonData.participantIds = options.participantIds;
    }
    if (options.ensureParticipantIds) {
        jsonData.ensureParticipantIds = options.ensureParticipantIds;
    }
    if (options.deleteParticipantIds) {
        jsonData.deleteParticipantIds = options.deleteParticipantIds;
    }
    if (options.label) {
        jsonData.label = options.label;
    }
    if (options.description) {
        jsonData.description = options.description;
    }
    if (options.filters) {
        jsonData.filters = options.filters;
    }
    return request({
        url: (0,ActionURL.buildURL)('participant-group', 'updateParticipantGroup.api', options.containerPath),
        method: 'POST',
        jsonData,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope, false, data => data.group),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), this, true),
    });
}

;// CONCATENATED MODULE: ./src/labkey/Pipeline.ts



function getFileStatus(config) {
    const onSuccess = (0,Utils.getOnSuccess)(config);
    return request({
        url: (0,ActionURL.buildURL)('pipeline-analysis', 'getFileStatus.api', config.containerPath),
        method: 'POST',
        params: {
            file: config.files,
            path: config.path,
            protocolName: config.protocolName,
            taskId: config.taskId,
        },
        success: (0,Utils.getCallbackWrapper)(function (data, response, options) {
            if (onSuccess) {
                onSuccess.call(this, data.files, data.submitType, response, options);
            }
        }, config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
        timeout: 60000000,
    });
}
function getPipelineContainer(config) {
    return request({
        url: (0,ActionURL.buildURL)('pipeline', 'getPipelineContainer.api', config.containerPath),
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function getProtocols(config) {
    const onSuccess = (0,Utils.getOnSuccess)(config);
    return request({
        url: (0,ActionURL.buildURL)('pipeline-analysis', 'getSavedProtocols.api', config.containerPath),
        method: 'POST',
        params: {
            includeWorkbooks: !!config.includeWorkbooks,
            path: config.path,
            taskId: config.taskId,
        },
        success: (0,Utils.getCallbackWrapper)(function (data, response, options) {
            if (onSuccess) {
                onSuccess.call(this, data.protocols, data.defaultProtocolName, response, options);
            }
        }, config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function startAnalysis(config) {
    if (!config.protocolName) {
        throw 'Invalid config, must include protocolName property';
    }
    const params = {
        allowNonExistentFiles: config.allowNonExistentFiles,
        file: config.files,
        fileIds: config.fileIds,
        path: config.path,
        pipelineDescription: config.pipelineDescription,
        protocolDescription: config.protocolDescription,
        protocolName: config.protocolName,
        saveProtocol: config.saveProtocol == undefined || config.saveProtocol,
        taskId: config.taskId,
    };
    if (config.xmlParameters) {
        if ((0,Utils.isObject)(config.xmlParameters))
            throw new Error('The xml configuration is deprecated, please use the jsonParameters option to specify your protocol description.');
        else
            params.configureXml = config.xmlParameters;
    }
    else if (config.jsonParameters) {
        params.configureJson = (0,Utils.isString)(config.jsonParameters) ? config.jsonParameters : (0,Utils.encode)(config.jsonParameters);
    }
    return request({
        url: (0,ActionURL.buildURL)('pipeline-analysis', 'startAnalysis.api', config.containerPath),
        method: 'POST',
        params,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
        timeout: 60000000,
    });
}

// EXTERNAL MODULE: ./src/labkey/query/Response.ts
var Response = __webpack_require__(889);
;// CONCATENATED MODULE: ./src/labkey/query/Utils.ts





var ContainerFilter;
(function (ContainerFilter) {
    ContainerFilter["allFolders"] = "AllFolders";
    ContainerFilter["allInProject"] = "AllInProject";
    ContainerFilter["allInProjectPlusShared"] = "AllInProjectPlusShared";
    ContainerFilter["current"] = "Current";
    ContainerFilter["currentAndFirstChildren"] = "CurrentAndFirstChildren";
    ContainerFilter["currentAndParents"] = "CurrentAndParents";
    ContainerFilter["currentAndSubfolders"] = "CurrentAndSubfolders";
    ContainerFilter["currentAndSubfoldersPlusShared"] = "CurrentAndSubfoldersPlusShared";
    ContainerFilter["currentPlusProject"] = "CurrentPlusProject";
    ContainerFilter["currentPlusProjectAndShared"] = "CurrentPlusProjectAndShared";
})(ContainerFilter || (ContainerFilter = {}));
const containerFilter = ContainerFilter;
const URL_COLUMN_PREFIX = '_labkeyurl_';
function buildQueryParams(schemaName, queryName, filterArray, sort, dataRegionName) {
    const regionName = (0,Utils.ensureRegionName)(dataRegionName);
    const params = {
        dataRegionName: regionName,
        [regionName + '.queryName']: queryName,
        schemaName,
    };
    if (sort) {
        params[regionName + '.sort'] = sort;
    }
    return appendFilterParams(params, filterArray, regionName);
}
function deleteQueryView(options) {
    if (!options) {
        throw 'You must specify a configuration!';
    }
    if (!options.schemaName) {
        throw 'You must specify a schemaName!';
    }
    if (!options.queryName) {
        throw 'You must specify a queryName!';
    }
    const jsonData = {
        schemaName: options.schemaName,
        queryName: options.queryName,
    };
    if (options.viewName) {
        jsonData.viewName = options.viewName;
    }
    if (options.revert !== undefined) {
        jsonData.complete = options.revert !== true;
    }
    return request({
        url: (0,ActionURL.buildURL)('query', 'deleteView.api', options.containerPath),
        method: 'POST',
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
        jsonData,
    });
}
function getDataViews(options) {
    const jsonData = {
        includeData: true,
        includeMetadata: false,
    };
    if (options.dataTypes) {
        jsonData.dataTypes = options.dataTypes;
    }
    const onSuccess = (0,Utils.getOnSuccess)(options);
    const success = (0,Utils.getCallbackWrapper)(function (data, response, options) {
        if (onSuccess) {
            onSuccess.call(options.scope || this, data.data, options, response);
        }
    }, this);
    return request({
        url: (0,ActionURL.buildURL)('reports', 'browseData.api', options.containerPath),
        method: 'POST',
        success,
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
        jsonData,
    });
}
function getMethod(value) {
    if (value && (value.toUpperCase() === 'GET' || value.toUpperCase() === 'POST'))
        return value.toUpperCase();
    return 'GET';
}
function getQueries(options) {
    const params = {};
    (0,Utils.applyTranslated)(params, options, {
        schemaName: 'schemaName',
        includeColumns: 'includeColumns',
        includeSystemQueries: 'includeSystemQueries',
        includeTitle: 'includeTitle',
        includeUserQueries: 'includeUserQueries',
        includeViewDataUrl: 'includeViewDataUrl',
        queryDetailColumns: 'queryDetailColumns',
    }, false, false);
    return request({
        url: (0,ActionURL.buildURL)('query', 'getQueries.api', options.containerPath),
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
        params,
    });
}
function getQueryViews(options) {
    const params = {};
    if (options.schemaName) {
        params.schemaName = options.schemaName;
    }
    if (options.queryName) {
        params.queryName = options.queryName;
    }
    if (options.viewName != undefined) {
        params.viewName = options.viewName;
    }
    if (options.metadata) {
        params.metadata = options.metadata;
    }
    if (options.excludeSessionView) {
        params.excludeSessionView = true;
    }
    return request({
        url: (0,ActionURL.buildURL)('query', 'getQueryViews.api', options.containerPath),
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
        params,
    });
}
function getSchemas(options) {
    const params = {};
    if (options.apiVersion) {
        params.apiVersion = options.apiVersion;
    }
    if (options.schemaName) {
        params.schemaName = options.schemaName;
    }
    if (options.includeHidden !== undefined) {
        params.includeHidden = options.includeHidden;
    }
    return request({
        url: (0,ActionURL.buildURL)('query', 'getSchemas.api', options.containerPath),
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
        params,
    });
}
function getServerDate(options) {
    const onSuccess = (0,Utils.getOnSuccess)(options);
    return request({
        url: (0,ActionURL.buildURL)('query', 'getServerDate.api'),
        success: (0,Utils.getCallbackWrapper)(onSuccess, options.scope, false, (json) => {
            if (json && json.date && onSuccess) {
                return (0,Utils.parseDateString)(json.date);
            }
        }),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
    });
}
const SUPPORTED_VERSIONS = [13.2, '13.2', 16.2, 17.1];
function getSuccessCallbackWrapper(onSuccess, stripHiddenCols, scope, requiredVersion) {
    if (SUPPORTED_VERSIONS.indexOf(requiredVersion) > -1) {
        return (0,Utils.getCallbackWrapper)(function (data, response, options) {
            if (data && onSuccess) {
                onSuccess.call(scope || this, new Response/* Response */.Y(data), response, options);
            }
        }, this);
    }
    return (0,Utils.getCallbackWrapper)(function (data, response, options) {
        if (onSuccess) {
            if (data && data.rows && stripHiddenCols) {
                stripHiddenColData(data);
            }
            onSuccess.call(scope || this, data, options, response);
        }
    }, this);
}
function saveQueryViews(options) {
    const jsonData = {};
    if (options.schemaName) {
        jsonData.schemaName = options.schemaName;
    }
    if (options.queryName) {
        jsonData.queryName = options.queryName;
    }
    if (options.views) {
        jsonData.views = options.views;
    }
    if (options.shared) {
        jsonData.shared = true;
    }
    if (options.session) {
        jsonData.session = true;
    }
    if (options.hidden) {
        jsonData.hidden = true;
    }
    return request({
        url: (0,ActionURL.buildURL)('query', 'saveQueryViews.api', options.containerPath),
        method: 'POST',
        jsonData,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
    });
}
function saveSessionView(options) {
    const jsonData = {};
    if (options.schemaName) {
        jsonData.schemaName = options.schemaName;
    }
    if (options.queryName) {
        jsonData['query.queryName'] = options.queryName;
    }
    if (options.viewName) {
        jsonData['query.viewName'] = options.viewName;
    }
    if (options.newName) {
        jsonData.newName = options.newName;
    }
    if (options.shared) {
        jsonData.shared = true;
    }
    if (options.inherit) {
        jsonData.inherit = true;
    }
    if (options.hidden) {
        jsonData.hidden = true;
    }
    if (options.replace) {
        jsonData.replace = true;
    }
    return request({
        url: (0,ActionURL.buildURL)('query', 'saveSessionView.api', options.containerPath),
        method: 'POST',
        jsonData,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
    });
}
function sqlDateLiteral(date) {
    if (date === undefined || date === null || !date) {
        return 'NULL';
    }
    if (typeof date === 'string') {
        try {
            date = new Date(date);
        }
        catch (x) { }
    }
    if (typeof date === 'object' && typeof date.toISOString === 'function') {
        const fmt2 = (a) => (a >= 10 ? '' + a : '0' + a);
        return "{d '" + date.getFullYear() + '-' + fmt2(date.getMonth() + 1) + '-' + fmt2(date.getDate()) + "'}";
    }
    return "{d '" + sqlStringLiteral(date.toString()) + "'}";
}
function sqlDateTimeLiteral(date, withMS) {
    if (date === undefined || date === null || !date) {
        return 'NULL';
    }
    if (typeof date === 'string') {
        try {
            date = new Date(date);
        }
        catch (x) { }
    }
    if (typeof date === 'object' && typeof date.toISOString === 'function') {
        const fmt2 = (a) => (a >= 10 ? '' + a : '0' + a);
        const fmt3 = (a) => (a >= 100 ? '' + a : '0' + fmt2(a));
        return ("{ts '" +
            date.getFullYear() +
            '-' +
            fmt2(date.getMonth() + 1) +
            '-' +
            fmt2(date.getDate()) +
            ' ' +
            fmt2(date.getHours()) +
            ':' +
            fmt2(date.getMinutes()) +
            ':' +
            fmt2(date.getSeconds()) +
            (withMS ? '.' + fmt3(date.getMilliseconds()) : '') +
            "'}");
    }
    return "{ts '" + this.sqlStringLiteral(date) + "'}";
}
function sqlStringLiteral(str) {
    if (str === undefined || str === null || str == '') {
        return 'NULL';
    }
    return "'" + str.toString().replace("'", "''") + "'";
}
function stripHiddenColData(data) {
    const hiddenCols = [];
    const newColModel = [];
    const newMetaFields = [];
    const colModel = data.columnModel;
    for (let i = 0; i < colModel.length; ++i) {
        if (colModel[i].hidden) {
            hiddenCols.push(colModel[i].dataIndex);
        }
        else {
            newColModel.push(colModel[i]);
            newMetaFields.push(data.metaData.fields[i]);
        }
    }
    data.columnModel = newColModel;
    data.metaData.fields = newMetaFields;
    for (let i = 0; i < data.rows.length; ++i) {
        const row = data.rows[i];
        for (let h = 0; h < hiddenCols.length; ++h) {
            delete row[hiddenCols[h]];
            delete row[URL_COLUMN_PREFIX + hiddenCols[h]];
        }
    }
}
function validateQuery(options) {
    const action = options.validateQueryMetadata ? 'validateQueryMetadata.api' : 'validateQuery.api';
    const params = {};
    (0,Utils.applyTranslated)(params, options, {
        successCallback: false,
        errorCallback: false,
        scope: false,
    });
    return request({
        url: (0,ActionURL.buildURL)('query', action, options.containerPath),
        params,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
    });
}

;// CONCATENATED MODULE: ./src/labkey/query/ExecuteSql.ts




function buildParams(options) {
    const jsonData = {
        schemaName: options.schemaName,
        sql: (0,Utils.wafEncode)(options.sql),
    };
    if (options.saveInSession !== undefined && options.saveInSession !== null) {
        jsonData.saveInSession = options.saveInSession;
    }
    if (options.maxRows !== undefined && options.maxRows >= 0) {
        jsonData.maxRows = options.maxRows;
    }
    if (options.offset && options.offset > 0) {
        jsonData.offset = options.offset;
    }
    if (options.includeTotalCount !== undefined) {
        jsonData.includeTotalCount = options.includeTotalCount;
    }
    if (options.containerFilter) {
        jsonData.containerFilter = options.containerFilter;
    }
    if (options.requiredVersion) {
        jsonData.apiVersion = options.requiredVersion;
    }
    if (options.includeStyle) {
        jsonData.includeStyle = options.includeStyle;
    }
    if (options.includeMetadata !== undefined) {
        jsonData.includeMetadata = options.includeMetadata;
    }
    return jsonData;
}
function buildURLParams(options) {
    const urlParams = {};
    if (options.sort) {
        urlParams['query.sort'] = options.sort;
    }
    if (options.parameters) {
        for (const propName in options.parameters) {
            if (options.parameters.hasOwnProperty(propName)) {
                urlParams['query.param.' + propName] = options.parameters[propName];
            }
        }
    }
    return urlParams;
}
function executeSql(options) {
    return request({
        url: (0,ActionURL.buildURL)('query', 'executeSql.api', options.containerPath, buildURLParams(options)),
        method: 'POST',
        success: getSuccessCallbackWrapper((0,Utils.getOnSuccess)(options), options.stripHiddenColumns, options.scope, options.requiredVersion),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
        jsonData: buildParams(options),
        timeout: options.timeout,
    });
}

// EXTERNAL MODULE: ./src/labkey/SchemaKey.ts
var SchemaKey = __webpack_require__(13);
;// CONCATENATED MODULE: ./src/labkey/query/GetData.ts






function getRawData(config) {
    const jsonData = validateGetDataConfig(config);
    jsonData.renderer.type = 'json';
    if (!config.success) {
        throw new Error('A success callback is required');
    }
    return request({
        url: (0,ActionURL.buildURL)('query', 'getData', config.source.containerPath),
        method: 'POST',
        jsonData,
        success: (response, options) => {
            const json = (0,Utils.decode)(response.responseText);
            config.success.call(config.scope || this, new Response/* Response */.Y(json), response, options);
        },
        failure: (response, options) => {
            const json = (0,Utils.decode)(response.responseText);
            if (config.failure) {
                config.failure(json);
            }
            else {
                if (response.status != 0) {
                    console.error('Failure occurred during getData', json);
                }
            }
        },
    });
}
function validateGetDataConfig(config) {
    if (!config || config === null || config === undefined) {
        throw new Error('A config object is required for GetData requests.');
    }
    const source = config.source;
    validateSource(source);
    const jsonData = {
        renderer: {},
        source: {
            schemaName: source.schemaName,
            type: source.type,
        },
    };
    if (source.type === 'query') {
        jsonData.source.queryName = source.queryName;
    }
    else if (source.type === 'sql') {
        jsonData.source.sql = (0,Utils.wafEncode)(source.sql);
    }
    if (config.transforms) {
        if (!(0,Utils.isArray)(config.transforms)) {
            throw new Error('transforms must be an array.');
        }
        jsonData.transforms = config.transforms;
        for (let i = 0; i < jsonData.transforms.length; i++) {
            validateTransform(jsonData.transforms[i]);
        }
    }
    if (config.pivot) {
        validatePivot(config.pivot);
    }
    if (config.columns) {
        if (!(0,Utils.isArray)(config.columns)) {
            throw new Error('columns must be an array of FieldKeys.');
        }
        for (let i = 0; i < config.columns.length; i++) {
            config.columns[i] = validateFieldKey(config.columns[i]);
            if (!config.columns[i]) {
                throw new Error('columns must be an array of FieldKeys.');
            }
        }
        jsonData.renderer.columns = config.columns;
    }
    if (config.hasOwnProperty('offset')) {
        jsonData.renderer.offset = config.offset;
    }
    if (config.hasOwnProperty('includeDetailsColumn')) {
        jsonData.renderer.includeDetailsColumn = config.includeDetailsColumn;
    }
    if (config.hasOwnProperty('maxRows')) {
        jsonData.renderer.maxRows = config.maxRows;
    }
    if (config.sort) {
        if (!(0,Utils.isArray)(config.sort)) {
            throw new Error('sort must be an array.');
        }
        for (let i = 0; i < config.sort.length; i++) {
            if (!config.sort[i].fieldKey) {
                throw new Error('Each sort must specify a field key.');
            }
            config.sort[i].fieldKey = validateFieldKey(config.sort[i].fieldKey);
            if (!config.sort[i].fieldKey) {
                throw new Error('Invalid field key specified for sort.');
            }
            if (config.sort[i].dir) {
                config.sort[i].dir = config.sort[i].dir.toUpperCase();
            }
        }
        jsonData.renderer.sort = config.sort;
    }
    return jsonData;
}
function validateFieldKey(key) {
    if (key instanceof FieldKey/* FieldKey */.W) {
        return key.getParts();
    }
    if (key instanceof Array) {
        return key;
    }
    if ((0,Utils.isString)(key)) {
        return FieldKey/* FieldKey */.W.fromString(key).getParts();
    }
    return undefined;
}
function validateFilter(filter) {
    if (filter && (0,Utils.isFunction)(filter.getColumnName)) {
        return {
            fieldKey: FieldKey/* FieldKey */.W.fromString(filter.getColumnName()).getParts(),
            type: filter.getFilterType().getURLSuffix(),
            value: filter.getValue(),
        };
    }
    if (filter.fieldKey) {
        filter.fieldKey = validateFieldKey(filter.fieldKey);
    }
    else {
        throw new Error('All filters must have a "fieldKey" attribute.');
    }
    if (!filter.fieldKey) {
        throw new Error('Filter fieldKeys must be valid FieldKeys');
    }
    if (!filter.type) {
        throw new Error('All filters must have a "type" attribute.');
    }
    return filter;
}
function validatePivot(pivot) {
    if (!pivot.columns || pivot.columns == null) {
        throw new Error('pivot.columns is required.');
    }
    if (!(0,Utils.isArray)(pivot.columns)) {
        throw new Error('pivot.columns must be an array of fieldKeys.');
    }
    for (let i = 0; i < pivot.columns.length; i++) {
        pivot.columns[i] = validateFieldKey(pivot.columns[i]);
        if (!pivot.columns[i]) {
            throw new Error('pivot.columns must be an array of fieldKeys.');
        }
    }
    if (!pivot.by || pivot.by == null) {
        throw new Error('pivot.by is required');
    }
    pivot.by = validateFieldKey(pivot.by);
    if (!pivot.by === false) {
        throw new Error('pivot.by must be a fieldKey.');
    }
}
function validateSchemaKey(key) {
    if (key instanceof SchemaKey/* SchemaKey */.z) {
        return key.getParts();
    }
    if (key instanceof Array) {
        return key;
    }
    if ((0,Utils.isString)(key)) {
        return SchemaKey/* SchemaKey */.z.fromString(key).getParts();
    }
    return undefined;
}
function validateSource(source) {
    if (!source || source == null) {
        throw new Error('A source is required for a GetData request.');
    }
    if (!source.type) {
        source.type = 'query';
    }
    if (source.type === 'query') {
        if (!source.queryName || source.queryName == null) {
            throw new Error('A queryName is required for getData requests with type = "query"');
        }
    }
    else if (source.type === 'sql') {
        if (!source.sql) {
            throw new Error('sql is required if source.type = "sql"');
        }
    }
    else {
        throw new Error('Unsupported source type.');
    }
    if (!source.schemaName) {
        throw new Error('A schemaName is required.');
    }
    source.schemaName = validateSchemaKey(source.schemaName);
    if (!source.schemaName) {
        throw new Error('schemaName must be a FieldKey');
    }
}
function validateTransform(transform) {
    if (!transform.type || transform.type !== 'aggregate') {
        transform.type = 'aggregate';
    }
    if (transform.groupBy && transform.groupBy != null) {
        if (!(0,Utils.isArray)(transform.groupBy)) {
            throw new Error('groupBy must be an array.');
        }
    }
    if (transform.aggregates && transform.aggregates != null) {
        if (!(0,Utils.isArray)(transform.aggregates)) {
            throw new Error('aggregates must be an array.');
        }
        for (let i = 0; i < transform.aggregates.length; i++) {
            if (!transform.aggregates[i].fieldKey) {
                throw new Error('All aggregates must include a fieldKey.');
            }
            transform.aggregates[i].fieldKey = validateFieldKey(transform.aggregates[i].fieldKey);
            if (!transform.aggregates[i].fieldKey) {
                throw new Error('Aggregate fieldKeys must be valid fieldKeys');
            }
            if (!transform.aggregates[i].type) {
                throw new Error('All aggregates must include a type.');
            }
        }
    }
    if (transform.filters && transform.filters != null) {
        if (!(0,Utils.isArray)(transform.filters)) {
            throw new Error('The filters of a transform must be an array.');
        }
        for (let i = 0; i < transform.filters.length; i++) {
            transform.filters[i] = validateFilter(transform.filters[i]);
        }
    }
}

;// CONCATENATED MODULE: ./src/labkey/query/GetQueryDetails.ts




function getQueryDetails(options) {
    const params = {};
    if (options.schemaName) {
        params.schemaName = options.schemaName;
    }
    if (options.queryName) {
        params.queryName = options.queryName;
    }
    if (options.viewName != undefined) {
        params.viewName = options.viewName;
    }
    if (options.fields) {
        params.fields = options.fields;
    }
    if (options.fk) {
        params.fk = options.fk;
    }
    if (options.initializeMissingView !== undefined) {
        params.initializeMissingView = options.initializeMissingView;
    }
    if (options.includeTriggers !== undefined) {
        params.includeTriggers = options.includeTriggers;
    }
    return request({
        url: (0,ActionURL.buildURL)('query', 'getQueryDetails.api', options.containerPath),
        method: getMethod(options.method),
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
        params,
    });
}

;// CONCATENATED MODULE: ./src/labkey/query/SelectDistinctRows.ts




function buildSelectDistinctParams(options) {
    const params = buildQueryParams(options.schemaName, options.queryName, options.filterArray, options.sort, options.dataRegionName);
    const dataRegionName = params.dataRegionName;
    params[dataRegionName + '.columns'] = options.column;
    if (options.viewName) {
        params[dataRegionName + '.viewName'] = options.viewName;
    }
    if (options.maxRows && options.maxRows >= 0) {
        params.maxRows = options.maxRows;
    }
    if (options.containerFilter) {
        params.containerFilter = options.containerFilter;
    }
    if (options.parameters) {
        for (const propName in options.parameters) {
            if (options.parameters.hasOwnProperty(propName)) {
                params[dataRegionName + '.param.' + propName] = options.parameters[propName];
            }
        }
    }
    if (options.ignoreFilter) {
        params[dataRegionName + '.ignoreFilter'] = true;
    }
    return params;
}
function selectDistinctRows(options) {
    if (!options.schemaName)
        throw 'You must specify a schemaName!';
    if (!options.queryName)
        throw 'You must specify a queryName!';
    if (!options.column)
        throw 'You must specify a column!';
    return request({
        url: (0,ActionURL.buildURL)('query', 'selectDistinct.api', options.containerPath),
        method: getMethod(options.method),
        success: getSuccessCallbackWrapper((0,Utils.getOnSuccess)(options), false, options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
        params: buildSelectDistinctParams(options),
    });
}

;// CONCATENATED MODULE: ./src/labkey/query/SelectRows.ts




function buildSelectRowsParams(options) {
    const params = buildQueryParams(options.schemaName, options.queryName, options.filterArray, options.sort, options.dataRegionName);
    const dataRegionName = params.dataRegionName;
    if (!options.showRows || options.showRows === 'paginated') {
        if (options.offset) {
            params[dataRegionName + '.offset'] = options.offset;
        }
        if (options.maxRows != undefined) {
            if (options.maxRows < 0) {
                params[dataRegionName + '.showRows'] = 'all';
            }
            else {
                params[dataRegionName + '.maxRows'] = options.maxRows;
            }
        }
    }
    else if (['all', 'selected', 'unselected', 'none'].indexOf(options.showRows) !== -1) {
        params[dataRegionName + '.showRows'] = options.showRows;
    }
    if (options.viewName)
        params[dataRegionName + '.viewName'] = options.viewName;
    if (options.columns)
        params[dataRegionName + '.columns'] = (0,Utils.isArray)(options.columns)
            ? options.columns.join(',')
            : options.columns;
    if (options.selectionKey)
        params[dataRegionName + '.selectionKey'] = options.selectionKey;
    if (options.ignoreFilter)
        params[dataRegionName + '.ignoreFilter'] = 1;
    if (options.parameters) {
        for (const propName in options.parameters) {
            if (options.parameters.hasOwnProperty(propName)) {
                params[dataRegionName + '.param.' + propName] = options.parameters[propName];
            }
        }
    }
    if (options.requiredVersion)
        params.apiVersion = options.requiredVersion;
    if (options.containerFilter)
        params.containerFilter = options.containerFilter;
    if (options.includeTotalCount !== undefined)
        params.includeTotalCount = options.includeTotalCount;
    if (options.includeDetailsColumn)
        params.includeDetailsColumn = options.includeDetailsColumn;
    if (options.includeUpdateColumn)
        params.includeUpdateColumn = options.includeUpdateColumn;
    if (options.includeStyle)
        params.includeStyle = options.includeStyle;
    if (options.includeMetadata !== undefined)
        params.includeMetadata = options.includeMetadata;
    return params;
}
function selectRowArguments(args) {
    return {
        schemaName: args[0],
        queryName: args[1],
        success: args[2],
        failure: args[3],
        filterArray: args[4],
        sort: args[5],
        viewName: args[6],
    };
}
function selectRows(options) {
    if (arguments.length > 1) {
        options = selectRowArguments(arguments);
    }
    if (!options || !options.schemaName) {
        throw 'You must specify a schemaName!';
    }
    if (!options.queryName) {
        throw 'You must specify a queryName!';
    }
    return request({
        url: (0,ActionURL.buildURL)('query', 'getQuery.api', options.containerPath),
        method: getMethod(options.method),
        success: getSuccessCallbackWrapper((0,Utils.getOnSuccess)(options), options.stripHiddenColumns, options.scope, options.requiredVersion),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
        params: buildSelectRowsParams(options),
        timeout: options.timeout,
    });
}

;// CONCATENATED MODULE: ./src/labkey/query/experimental/SQL.ts



const CONTROL_CHARS = {
    nul: '\x00',
    bs: '\x08',
    rs: '\x1E',
    us: '\x1F',
};
const CONVERTERS = {
    BIGINT: parseInt,
    BOOLEAN: parseInt,
    DOUBLE: parseFloat,
    INTEGER: parseInt,
    NUMERIC: parseFloat,
    REAL: parseFloat,
    SMALLINT: parseInt,
    TIMESTAMP: convertDate,
    TINYINT: parseInt,
};
function asObjects(fields, rows) {
    const p = {};
    for (let f = 0; f < fields.length; f++) {
        p[fields[f]] = null;
    }
    const result = [];
    for (let r = 0; r < rows.length; r++) {
        const arr = rows[r];
        const obj = Object.assign({}, p);
        const l = Math.min(fields.length, arr.length);
        for (let c = 0; c < l; c++) {
            obj[fields[c]] = arr[c];
        }
        result.push(obj);
    }
    return result;
}
function convertDate(s) {
    if (!s) {
        return null;
    }
    let number;
    if (s.indexOf('-') > 0) {
        number = Date.parse(s);
    }
    else {
        number = parseFloat(s);
    }
    return new Date(!isNaN(number) && isFinite(number) ? number : s);
}
function execute(options) {
    if (!options.schema) {
        throw 'You must specify a schema!';
    }
    if (!options.sql) {
        throw 'You must specify sql statement!';
    }
    const eol = options.eol || CONTROL_CHARS.us + '\n';
    const sep = options.sep || CONTROL_CHARS.us + '\t';
    const jsonData = {
        compact: 1,
        eol,
        parameters: options.parameters,
        schema: options.schema,
        sep,
        sql: (0,Utils.wafEncode)(options.sql),
    };
    return request({
        url: (0,ActionURL.buildURL)('sql', 'execute', options.containerPath),
        method: 'POST',
        jsonData,
        success: response => {
            const result = parseRows(response.responseText, sep, eol);
            (0,Utils.getOnSuccess)(options)(result);
        },
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
        timeout: options.timeout,
    });
}
function identity(x) {
    return x;
}
function parseRows(text, sep, eol) {
    let rows = text.split(eol);
    if (trimRight(rows[rows.length - 1]) === '') {
        rows.pop();
    }
    let x = 0;
    const meta = rows[x++].split(sep);
    const names = rows[x++].split(sep);
    const colConverters = [];
    const types = rows[x++].split(sep);
    for (let i = 0; i < types.length; i++) {
        colConverters.push(CONVERTERS[types[i]] || identity);
    }
    rows = rows.slice(meta.length);
    for (let r = 0; r < rows.length; r++) {
        const row = rows[r].split(sep);
        for (let c = 0; c < row.length; c++) {
            const s = row[c];
            if (s === '') {
                row[c] = null;
            }
            else if (CONTROL_CHARS.bs === s && r > 0) {
                row[c] = rows[r - 1][c];
            }
            else {
                row[c] = colConverters[c](s);
            }
        }
        rows[r] = row;
    }
    return {
        names,
        rows,
        types,
    };
}
function trimRight(s) {
    return s.replace(/[\s\uFEFF\xA0]+$/g, '');
}

;// CONCATENATED MODULE: ./src/labkey/query/visualization/constants.ts
var Aggregate;
(function (Aggregate) {
    Aggregate["AVG"] = "AVG";
    Aggregate["COUNT"] = "COUNT";
    Aggregate["MAX"] = "MAX";
    Aggregate["MIN"] = "MIN";
    Aggregate["SUM"] = "SUM";
})(Aggregate || (Aggregate = {}));
var Interval;
(function (Interval) {
    Interval["DAY"] = "DAY";
    Interval["MONTH"] = "MONTH";
    Interval["WEEK"] = "WEEK";
    Interval["YEAR"] = "YEAR";
})(Interval || (Interval = {}));
const Type = {
    GenericChart: 'ReportService.GenericChartReport',
    TimeChart: 'ReportService.TimeChartReport',
};

;// CONCATENATED MODULE: ./src/labkey/query/visualization/Dimension.ts



function createValues(json) {
    if (json && json.success && json.values) {
        return json.values;
    }
    return [];
}
class Dimension {
    constructor(config) {
        if (config && config.hasOwnProperty('isUserDefined')) {
            this._isUserDefined = config['isUserDefined'];
        }
        (0,Utils.apply)(this, config);
    }
    getDescription() {
        return this.description;
    }
    getLabel() {
        return this.label;
    }
    getName() {
        return this.name;
    }
    getQueryName() {
        return this.queryName;
    }
    getSchemaName() {
        return this.schemaName;
    }
    getType() {
        return this.type;
    }
    getValues(options) {
        return request({
            url: (0,ActionURL.buildURL)('visualization', 'getDimensionValues.api'),
            params: {
                name: this.name,
                queryName: this.queryName,
                schemaName: this.schemaName,
            },
            success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope, false, createValues),
            failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
        });
    }
    isUserDefined() {
        return this._isUserDefined;
    }
}

;// CONCATENATED MODULE: ./src/labkey/query/visualization/Filter.ts
function Filter_create(options) {
    if (!options.schemaName) {
        throw new Error('You must supply a value for schemaName in your configuration object!');
    }
    const params = [options.schemaName, options.queryName ? options.queryName : '~'];
    if (options.queryType) {
        params.push(options.queryType);
    }
    return params.join('|');
}
const QueryType = {
    BUILT_IN: 'builtIn',
    CUSTOM: 'custom',
    DATASETS: 'datasets',
    ALL: 'all',
};

;// CONCATENATED MODULE: ./src/labkey/query/visualization/Measure.ts




function createDimensions(json) {
    const dimensions = [];
    if (json.dimensions && json.dimensions.length) {
        for (let i = 0; i < json.dimensions.length; i++) {
            dimensions.push(new Dimension(json.dimensions[i]));
        }
    }
    return dimensions;
}
class Measure {
    constructor(config) {
        if (config && config.hasOwnProperty('isUserDefined')) {
            this._isUserDefined = config['isUserDefined'];
        }
        (0,Utils.apply)(this, config);
    }
    getDescription() {
        return this.description;
    }
    getDimensions(options) {
        const params = {
            queryName: this.queryName,
            schemaName: this.schemaName,
        };
        if (options.includeDemographics) {
            params.includeDemographics = true;
        }
        return request({
            url: (0,ActionURL.buildURL)('visualization', 'getDimensions.api'),
            params,
            success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope, false, createDimensions),
            failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
        });
    }
    getLabel() {
        return this.label;
    }
    getName() {
        return this.name;
    }
    getQueryName() {
        return this.queryName;
    }
    getSchemaName() {
        return this.schemaName;
    }
    getType() {
        return this.type;
    }
    isUserDefined() {
        return this._isUserDefined;
    }
}

;// CONCATENATED MODULE: ./src/labkey/query/Visualization.ts








function createMeasures(json) {
    const measures = [];
    if (json.measures && json.measures.length) {
        for (let i = 0; i < json.measures.length; i++) {
            measures.push(new Measure(json.measures[i]));
        }
    }
    return measures;
}
function createTypes(json) {
    if (json && json.types && json.types.length) {
        return json.types;
    }
    return [];
}
function Visualization_get(options) {
    const jsonData = {
        name: options.name,
        reportId: options.reportId,
        queryName: options.queryName,
        schemaName: options.schemaName,
    };
    const processPayload = (json) => {
        if (json && json.visualizationConfig) {
            json.visualizationConfig = (0,Utils.decode)(json.visualizationConfig);
        }
        return json;
    };
    return request({
        url: (0,ActionURL.buildURL)('visualization', 'getVisualization.api'),
        method: 'POST',
        initialConfig: options,
        jsonData,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope, false, processPayload),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
    });
}
function getData(options) {
    const jsonData = {
        measures: [],
        sorts: options.sorts,
        filterQuery: options.filterQuery,
        filterUrl: options.filterUrl,
        limit: options.limit,
        groupBys: options.groupBys,
        metaDataOnly: options.metaDataOnly,
        joinToFirst: options.joinToFirst === true,
    };
    let filters, m, f, asURL, fa;
    for (m = 0; m < options.measures.length; m++) {
        const c = options.measures[m];
        const measure = {
            measure: c.measure,
            time: c.time,
        };
        if (c.dimension) {
            measure.dimension = c.dimension;
        }
        if (c.dateOptions) {
            measure.dateOptions = c.dateOptions;
        }
        if (c.filterArray) {
            measure.filterArray = c.filterArray;
            filters = [];
            for (f = 0; f < measure.filterArray.length; f++) {
                fa = measure.filterArray[f];
                if (fa && fa.getURLParameterName) {
                    asURL =
                        encodeURIComponent(fa.getURLParameterName()) +
                            '=' +
                            encodeURIComponent(fa.getURLParameterValue());
                    filters.push(asURL);
                }
            }
            measure.filterArray = filters;
        }
        jsonData.measures.push(measure);
    }
    const urlParams = {};
    if (options.parameters) {
        for (const p in options.parameters) {
            if (options.parameters.hasOwnProperty(p)) {
                urlParams['visualization.param.' + p] = options.parameters[p];
            }
        }
    }
    let url;
    if (options.endpoint) {
        url = options.endpoint + '?' + (0,ActionURL.queryString)(urlParams);
    }
    else {
        url = (0,ActionURL.buildURL)('visualization', 'getData', options.containerPath, urlParams);
    }
    return request({
        url,
        method: 'POST',
        jsonData,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
    });
}
function getDataFilterFromURL() {
    return (0,ActionURL.getParameters)().filterUrl;
}
function getFromUrl(options) {
    const params = options || {};
    params.success = (0,Utils.getOnSuccess)(options);
    params.failure = (0,Utils.getOnFailure)(options);
    const urlParams = (0,ActionURL.getParameters)();
    let valid = false;
    if (params.reportId) {
        valid = true;
    }
    else {
        if (urlParams.name) {
            params.name = urlParams.name;
            params.schemaName = urlParams.schemaName;
            params.queryName = urlParams.queryName;
            valid = true;
        }
    }
    if (valid) {
        Visualization_get(params);
    }
    return valid;
}
function getMeasures(options) {
    const params = {};
    if (options.filters && options.filters.length) {
        params.filters = options.filters;
    }
    if (options.dateMeasures !== undefined) {
        params.dateMeasures = options.dateMeasures;
    }
    if (options.allColumns !== undefined) {
        params.allColumns = options.allColumns;
    }
    if (options.showHidden !== undefined) {
        params.showHidden = options.showHidden;
    }
    return request({
        url: (0,ActionURL.buildURL)('visualization', 'getMeasures.api'),
        params,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope, false, createMeasures),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
    });
}
function getTypes(options) {
    return request({
        url: (0,ActionURL.buildURL)('visualization', 'getVisualizationTypes.api'),
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope, false, createTypes),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
    });
}
function Visualization_save(options) {
    const jsonData = {
        description: options.description,
        json: (0,Utils.encode)(options.visualizationConfig),
        name: options.name,
        replace: options.replace,
        shared: options.shared,
        thumbnailType: options.thumbnailType,
        iconType: options.iconType,
        svg: options.svg,
        type: options.type,
        schemaName: options.schemaName,
        queryName: options.queryName,
    };
    return request({
        url: (0,ActionURL.buildURL)('visualization', 'saveVisualization.api'),
        method: 'POST',
        jsonData,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
    });
}

;// CONCATENATED MODULE: ./src/labkey/Query.ts











const experimental = {
    SQL: SQL_namespaceObject,
};


// EXTERNAL MODULE: ./src/labkey/QueryKey.ts
var QueryKey = __webpack_require__(300);
;// CONCATENATED MODULE: ./src/labkey/Report.ts



function createSession(options) {
    return request({
        url: (0,ActionURL.buildURL)('reports', 'createSession.api', options.containerPath),
        method: 'POST',
        jsonData: {
            clientContext: options.clientContext,
        },
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
    });
}
function deleteSession(options) {
    return request({
        url: (0,ActionURL.buildURL)('reports', 'deleteSession.api', options.containerPath),
        method: 'POST',
        params: {
            reportSessionId: options.reportSessionId,
        },
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
    });
}
function requestExecute(options, isReport) {
    const jsonData = {};
    if (isReport) {
        if (options.reportId) {
            jsonData.reportId = options.reportId;
        }
        if (options.reportName) {
            jsonData.reportName = options.reportName;
        }
        if (options.schemaName) {
            jsonData.schemaName = options.schemaName;
        }
        if (options.queryName) {
            jsonData.queryName = options.queryName;
        }
    }
    else {
        if (options.functionName) {
            jsonData.functionName = options.functionName;
        }
    }
    if (options.reportSessionId) {
        jsonData.reportSessionId = options.reportSessionId;
    }
    if (options.inputParams) {
        for (const i in options.inputParams) {
            if (options.inputParams.hasOwnProperty(i)) {
                jsonData['inputParams[' + i + ']'] = options.inputParams[i];
            }
        }
    }
    return request({
        url: (0,ActionURL.buildURL)('reports', 'execute.api', options.containerPath),
        method: 'POST',
        jsonData,
        success: requestExecuteWrapper((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
    });
}
function requestExecuteWrapper(callback, scope) {
    return (0,Utils.getCallbackWrapper)(function (data, response, options) {
        if (data && data.outputParams) {
            for (let i = 0; i < data.outputParams.length; i++) {
                const param = data.outputParams[i];
                if (param.type == 'json') {
                    param.value = (0,Utils.decode)(param.value);
                }
            }
        }
        if (callback) {
            callback.call(scope || this, data, options, response);
        }
    }, this);
}
function Report_execute(options) {
    if (!options) {
        throw 'You must supply a config object to call this method.';
    }
    if (!options.reportId && !options.reportName) {
        throw 'You must supply a value for the reportId or reportName config property.';
    }
    return requestExecute(options, true);
}
function executeFunction(options) {
    if (!options) {
        throw 'You must supply a config object to call this method.';
    }
    if (!options.functionName) {
        throw 'You must supply a value for the functionName config property.';
    }
    return requestExecute(options, false);
}
function getSessions(options) {
    return request({
        url: (0,ActionURL.buildURL)('reports', 'getSessions.api', options.containerPath),
        method: 'POST',
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
    });
}

;// CONCATENATED MODULE: ./src/labkey/security/Container.ts




function createContainer(config) {
    return request({
        url: (0,ActionURL.buildURL)('core', 'createContainer.api', config.containerPath),
        method: 'POST',
        jsonData: {
            description: config.description,
            folderType: config.folderType,
            isWorkbook: config.isWorkbook,
            name: config.name,
            title: config.title,
        },
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function deleteContainer(config) {
    return request({
        url: (0,ActionURL.buildURL)('core', 'deleteContainer.api', config.containerPath),
        method: 'POST',
        jsonData: { comment: config.comment },
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function renameContainer(config) {
    return request({
        url: (0,ActionURL.buildURL)('admin', 'renameContainer.api', config.containerPath),
        method: 'POST',
        jsonData: { name: config.name, title: config.title, addAlias: config.addAlias },
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function getContainers(config) {
    const params = {};
    if (config) {
        if (config.container != undefined) {
            if ((0,Utils.isArray)(config.container)) {
                params.multipleContainers = true;
                params.container = config.container;
            }
            else {
                params.container = [config.container];
            }
        }
        if (config.includeSubfolders != undefined) {
            params.includeSubfolders = config.includeSubfolders;
        }
        if (config.depth != undefined) {
            params.depth = config.depth;
        }
        if (config.moduleProperties != undefined) {
            params.moduleProperties = config.moduleProperties;
        }
        if (config.includeEffectivePermissions != undefined) {
            params.includeEffectivePermissions = config.includeEffectivePermissions;
        }
        if (config.includeWorkbookChildren != undefined) {
            params.includeWorkbookChildren = config.includeWorkbookChildren;
        }
        if (config.includeStandardProperties != undefined) {
            params.includeStandardProperties = config.includeStandardProperties;
        }
    }
    return request({
        url: (0,ActionURL.buildURL)('project', 'getContainers.api', config.containerPath),
        params,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function getFolderTypes(config) {
    return request({
        url: (0,ActionURL.buildURL)('core', 'getFolderTypes.api', config.containerPath),
        method: 'POST',
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function getHomeContainer() {
    return (0,constants/* getServerContext */.$K)().homeContainer;
}
function getModules(config) {
    return request({
        url: (0,ActionURL.buildURL)('admin', 'getModules.api', config.containerPath),
        method: 'POST',
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function getReadableContainers(options) {
    const params = {};
    if (undefined !== options.container) {
        if ((0,Utils.isArray)(options.container)) {
            if (options.container.length > 0) {
                options.container = [options.container[0]];
            }
            else {
                delete options.container;
            }
        }
        else {
            options.container = [options.container];
        }
        params.container = options.container;
    }
    if (undefined !== options.includeSubfolders) {
        params.includeSubfolders = options.includeSubfolders;
    }
    if (undefined !== options.depth) {
        params.depth = options.depth;
    }
    return request({
        url: (0,ActionURL.buildURL)('project', 'getReadableContainers.api', options.containerPath),
        params,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope, false, (o) => o.containers),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
    });
}
function getSharedContainer() {
    return (0,constants/* getServerContext */.$K)().sharedContainer;
}
function moveContainer(config) {
    const params = {
        addAlias: config.addAlias !== false,
        container: config.container || config.containerPath,
        parent: config.destinationParent || config.parent || config.parentPath,
    };
    if (!params.container) {
        throw "'containerPath' must be specified for LABKEY.Security.moveContainer invocation.";
    }
    if (!params.parent) {
        throw "'parent' must be specified for LABKEY.Security.moveContainer invocation.";
    }
    return request({
        url: (0,ActionURL.buildURL)('core', 'moveContainer.api', params.container),
        method: 'POST',
        jsonData: params,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}

;// CONCATENATED MODULE: ./src/labkey/security/Permission.ts




function getGroupPermissions(config) {
    const params = {};
    if (config.includeSubfolders != undefined) {
        params.includeSubfolders = config.includeSubfolders;
    }
    return request({
        url: (0,ActionURL.buildURL)('security', 'getGroupPerms.api', config.containerPath),
        params,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function getRole(perms) {
    for (const role in roles) {
        if (roles.hasOwnProperty(role)) {
            if (perms === roles[role]) {
                return role;
            }
        }
    }
}
function getRoles(config) {
    return request({
        url: (0,ActionURL.buildURL)('security', 'getRoles.api', config.containerPath),
        success: (0,Utils.getCallbackWrapper)(function (data, req) {
            let i, j, permMap = {}, perm, role;
            for (i = 0; i < data.permissions.length; i++) {
                perm = data.permissions[i];
                permMap[perm.uniqueName] = perm;
            }
            for (i = 0; i < data.roles.length; i++) {
                role = data.roles[i];
                for (j = 0; j < role.permissions.length; ++j) {
                    role.permissions[j] = permMap[role.permissions[j]];
                }
            }
            const success = (0,Utils.getOnSuccess)(config);
            if (success) {
                success.call(config.scope || this, data.roles, req);
            }
        }, this),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function getSchemaPermissions(config) {
    if (!config.schemaName || (config.schemaName && config.schemaName !== 'study')) {
        throw 'Method only works for the study schema';
    }
    return getSecurableResources(Object.assign(Object.assign({}, config), { includeEffectivePermissions: true, success: function (json, response) {
            let studyResource = null;
            for (let i = 0; i < json.resources.children.length; i++) {
                const resource = json.resources.children[i];
                if (resource.resourceClass == 'org.labkey.study.model.StudyImpl') {
                    studyResource = resource;
                    break;
                }
            }
            if (studyResource == null) {
                config.failure.apply(config.scope || this, [{ description: 'No study found in container.' }, response]);
                return;
            }
            let result = {
                queries: {},
            }, dataset;
            for (let i = 0; i < studyResource.children.length; i++) {
                dataset = studyResource.children[i];
                result.queries[dataset.name] = dataset;
                dataset.permissionMap = {};
                for (let j = 0; j < dataset.effectivePermissions.length; j++) {
                    dataset.permissionMap[dataset.effectivePermissions[j]] = true;
                }
            }
            config.success.apply(config.scope || this, [{ schemas: { study: result } }, response]);
        } }));
}
function getSecurableResources(config) {
    const params = {};
    if (config.includeSubfolders != undefined) {
        params.includeSubfolders = config.includeSubfolders;
    }
    if (config.includeEffectivePermissions != undefined) {
        params.includeEffectivePermissions = config.includeEffectivePermissions;
    }
    return request({
        url: (0,ActionURL.buildURL)('security', 'getSecurableResources.api', config.containerPath),
        params,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function getUserPermissions(config) {
    const params = {};
    if (config.userId != undefined) {
        params.userId = config.userId;
    }
    else if (config.userEmail != undefined) {
        params.userEmail = config.userEmail;
    }
    if (config.includeSubfolders != undefined) {
        params.includeSubfolders = config.includeSubfolders;
    }
    return request({
        url: (0,ActionURL.buildURL)('security', 'getUserPerms.api', config.containerPath),
        params,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function hasEffectivePermission(effectivePermissions, desiredPermission) {
    return effectivePermissions.some(ep => ep === desiredPermission);
}
function hasPermission(perms, perm) {
    return perms & perm;
}

;// CONCATENATED MODULE: ./src/labkey/security/User.ts




function createNewUser(config) {
    return request({
        url: (0,ActionURL.buildURL)('security', 'createNewUser.api', config.containerPath),
        method: 'POST',
        jsonData: {
            email: config.email,
            sendEmail: config.sendEmail,
            optionalMessage: config.optionalMessage,
        },
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function ensureLogin(config) {
    if ((0,constants/* getServerContext */.$K)().user.isGuest || config.force) {
        if (config.useSiteLoginPage) {
            if (typeof window !== undefined) {
                window.location.href = (0,ActionURL.buildURL)('login', 'login') + '?returnUrl=' + (0,constants/* getLocation */.g$)();
            }
        }
        else {
            return request({
                url: (0,ActionURL.buildURL)('security', 'ensureLogin.api'),
                success: (0,Utils.getCallbackWrapper)(function (data, req) {
                    if (data.currentUser) {
                        (0,constants/* setGlobalUser */.Rj)(data.currentUser);
                    }
                    if ((0,Utils.getOnSuccess)(config)) {
                        (0,Utils.getOnSuccess)(config).call(config.scope || this, data, req);
                    }
                }, this),
                failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
            });
        }
    }
    else {
        (0,Utils.getOnSuccess)(config).call(config.scope);
    }
}
function parseGetUsersOptions(config) {
    const params = {};
    if (config.groupId !== undefined) {
        params.groupId = config.groupId;
    }
    else if (config.group !== undefined) {
        params.group = config.group;
    }
    if (config.name) {
        params.name = config.name;
    }
    if (config.allMembers != undefined) {
        params.allMembers = config.allMembers;
    }
    if (config.active != undefined) {
        params.active = config.active;
    }
    if (config.permissions != undefined) {
        if ((0,Utils.isArray)(config.permissions)) {
            params.permissions = config.permissions;
        }
        else {
            params.permissions = [config.permissions];
        }
    }
    return params;
}
function getUsers(config) {
    return request({
        url: (0,ActionURL.buildURL)('user', 'getUsers.api', config.containerPath),
        params: parseGetUsersOptions(config),
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function getUsersWithPermissions(config) {
    const params = parseGetUsersOptions(config);
    if (config.includeInactive !== undefined) {
        params.includeInactive = config.includeInactive;
    }
    if (config.requiredVersion !== undefined) {
        params.apiVersion = config.requiredVersion;
    }
    return request({
        url: (0,ActionURL.buildURL)('user', 'getUsersWithPermissions.api', config.containerPath),
        params,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}

;// CONCATENATED MODULE: ./src/labkey/security/Group.ts



function addGroupMembers(config) {
    return request({
        url: (0,ActionURL.buildURL)('security', 'addGroupMember.api', config.containerPath),
        method: 'POST',
        jsonData: {
            groupId: config.groupId,
            principalIds: (0,Utils.isArray)(config.principalIds) ? config.principalIds : [config.principalIds],
        },
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function createGroup(config) {
    return request({
        url: (0,ActionURL.buildURL)('security', 'createGroup.api', config.containerPath),
        method: 'POST',
        jsonData: {
            name: config.groupName,
        },
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function deleteGroup(config) {
    return request({
        url: (0,ActionURL.buildURL)('security', 'deleteGroup.api', config.containerPath),
        method: 'POST',
        jsonData: {
            id: config.groupId,
        },
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function getGroupsForCurrentUser(config) {
    return request({
        url: (0,ActionURL.buildURL)('security', 'getGroupsForCurrentUser.api', config.containerPath),
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function removeGroupMembers(config) {
    return request({
        url: (0,ActionURL.buildURL)('security', 'removeGroupMember.api', config.containerPath),
        method: 'POST',
        jsonData: {
            groupId: config.groupId,
            principalIds: (0,Utils.isArray)(config.principalIds) ? config.principalIds : [config.principalIds],
        },
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function renameGroup(config) {
    return request({
        url: (0,ActionURL.buildURL)('security', 'renameGroup.api', config.containerPath),
        method: 'POST',
        jsonData: {
            id: config.groupId,
            newName: config.newName,
        },
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}

;// CONCATENATED MODULE: ./src/labkey/security/Policy.ts



function deletePolicy(config) {
    return request({
        url: (0,ActionURL.buildURL)('security', 'deletePolicy.api', config.containerPath),
        method: 'POST',
        jsonData: {
            resourceId: config.resourceId,
        },
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function getPolicy(config) {
    return request({
        url: (0,ActionURL.buildURL)('security', 'getPolicy.api', config.containerPath),
        jsonData: {
            resourceId: config.resourceId,
        },
        success: (0,Utils.getCallbackWrapper)(function (data, req) {
            data.policy.requestedResourceId = config.resourceId;
            (0,Utils.getOnSuccess)(config).call(config.scope || this, data.policy, data.relevantRoles, req);
        }, this),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function savePolicy(config) {
    var _a;
    return request({
        url: (0,ActionURL.buildURL)('security', 'savePolicy.api', config.containerPath),
        method: 'POST',
        jsonData: (_a = config.policy.policy) !== null && _a !== void 0 ? _a : config.policy,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}

;// CONCATENATED MODULE: ./src/labkey/Security.ts








;// CONCATENATED MODULE: ./src/labkey/Specimen.ts



function addSpecimensToRequest(options) {
    if (remapArguments(options, arguments)) {
        options = {
            success: arguments[0],
            requestId: arguments[1],
            specimenHashArray: arguments[2],
            preferredLocation: arguments[3],
            failure: arguments[4],
            containerPath: arguments[5],
        };
    }
    return request({
        url: (0,ActionURL.buildURL)('specimen-api', 'addSpecimensToRequest.api', options.containerPath),
        method: 'POST',
        jsonData: {
            preferredLocation: options.preferredLocation,
            requestId: options.requestId,
            specimenHashes: options.specimenHashArray,
        },
        success: (0,Utils.getCallbackWrapper)(onSpecimenSuccess(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)(rebindFailure((0,Utils.getOnFailure)(options)), options.scope, true),
    });
}
const addSamplesToRequest = addSpecimensToRequest;
function addVialsToRequest(options) {
    if (remapArguments(options, arguments)) {
        options = {
            success: arguments[0],
            requestId: arguments[1],
            vialIdArray: arguments[2],
            idType: arguments[3],
            failure: arguments[4],
            containerPath: arguments[5],
        };
    }
    if (!options.idType) {
        options.idType = 'GlobalUniqueId';
    }
    return request({
        url: (0,ActionURL.buildURL)('specimen-api', 'addVialsToRequest.api', options.containerPath),
        method: 'POST',
        jsonData: {
            idType: options.idType,
            requestId: options.requestId,
            vialIds: options.vialIdArray,
        },
        success: (0,Utils.getCallbackWrapper)(onSpecimenSuccess(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)(rebindFailure((0,Utils.getOnFailure)(options)), options.scope, true),
    });
}
function cancelRequest(options) {
    if (remapArguments(options, arguments)) {
        options = {
            success: arguments[0],
            requestId: arguments[1],
            failure: arguments[2],
            containerPath: arguments[3],
        };
    }
    return request({
        url: (0,ActionURL.buildURL)('specimen-api', 'cancelRequest.api', options.containerPath),
        method: 'POST',
        jsonData: {
            requestId: options.requestId,
        },
        success: (0,Utils.getCallbackWrapper)(onSpecimenSuccess(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)(rebindFailure((0,Utils.getOnFailure)(options)), options.scope, true),
    });
}
function getOpenRequests(options) {
    if (remapArguments(options, arguments)) {
        options = {
            success: arguments[0],
            allUsers: arguments[1],
            failure: arguments[2],
            containerPath: arguments[3],
        };
    }
    return request({
        url: (0,ActionURL.buildURL)('specimen-api', 'getOpenRequests.api', options.containerPath),
        method: 'POST',
        jsonData: {
            allUsers: options.allUsers,
        },
        success: (0,Utils.getCallbackWrapper)(onSpecimenSuccess(options), options.scope, false, data => data.requests),
        failure: (0,Utils.getCallbackWrapper)(rebindFailure((0,Utils.getOnFailure)(options)), options.scope, true),
    });
}
function getProvidingLocations(options) {
    if (remapArguments(options, arguments)) {
        options = {
            success: arguments[0],
            specimenHashArray: arguments[1],
            failure: arguments[2],
            containerPath: arguments[3],
        };
    }
    return request({
        url: (0,ActionURL.buildURL)('specimen-api', 'getProvidingLocations.api', options.containerPath),
        method: 'POST',
        jsonData: {
            specimenHashes: options.specimenHashArray,
        },
        success: (0,Utils.getCallbackWrapper)(onSpecimenSuccess(options), options.scope, false, data => data.locations),
        failure: (0,Utils.getCallbackWrapper)(rebindFailure((0,Utils.getOnFailure)(options)), options.scope, true),
    });
}
function getRepositories(options) {
    if (remapArguments(options, arguments)) {
        options = {
            success: arguments[0],
            failure: arguments[1],
            containerPath: arguments[2],
        };
    }
    return request({
        url: (0,ActionURL.buildURL)('specimen-api', 'getRepositories.api', options.containerPath),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        success: (0,Utils.getCallbackWrapper)(onSpecimenSuccess(options), options.scope, false, data => data.repositories),
        failure: (0,Utils.getCallbackWrapper)(rebindFailure((0,Utils.getOnFailure)(options)), options.scope, true),
    });
}
function getRequest(options) {
    if (remapArguments(options, arguments)) {
        options = {
            success: arguments[0],
            requestId: arguments[1],
            failure: arguments[2],
            containerPath: arguments[3],
        };
    }
    return request({
        url: (0,ActionURL.buildURL)('specimen-api', 'getRequest.api', options.containerPath),
        method: 'POST',
        jsonData: {
            requestId: options.requestId,
        },
        success: (0,Utils.getCallbackWrapper)(onSpecimenSuccess(options), options.scope, false, data => data.request),
        failure: (0,Utils.getCallbackWrapper)(rebindFailure((0,Utils.getOnFailure)(options)), options.scope, true),
    });
}
function getSpecimenWebPartGroups(options) {
    return request({
        url: (0,ActionURL.buildURL)('specimen-api', 'getSpecimenWebPartGroups.api', options.containerPath),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        success: (0,Utils.getCallbackWrapper)(onSpecimenSuccess(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)(rebindFailure((0,Utils.getOnFailure)(options)), options.scope, true),
    });
}
function getVialsByRowId(options) {
    if (remapArguments(options, arguments)) {
        options = {
            success: arguments[0],
            vialRowIdArray: arguments[1],
            failure: arguments[2],
            containerPath: arguments[3],
        };
    }
    return request({
        url: (0,ActionURL.buildURL)('specimen-api', 'getVialsByRowId.api', options.containerPath),
        method: 'POST',
        jsonData: {
            rowIds: options.vialRowIdArray,
        },
        success: (0,Utils.getCallbackWrapper)(onSpecimenSuccess(options), options.scope, false, data => data.vials),
        failure: (0,Utils.getCallbackWrapper)(rebindFailure((0,Utils.getOnFailure)(options)), options.scope, true),
    });
}
function getVialTypeSummary(options) {
    return request({
        url: (0,ActionURL.buildURL)('specimen-api', 'getVialTypeSummary.api', options.containerPath),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        success: (0,Utils.getCallbackWrapper)(onSpecimenSuccess(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)(rebindFailure((0,Utils.getOnFailure)(options)), options.scope, true),
    });
}
function removeVialsFromRequest(options) {
    if (remapArguments(options, arguments)) {
        options = {
            success: arguments[0],
            requestId: arguments[1],
            vialIdArray: arguments[2],
            idType: arguments[3],
            failure: arguments[4],
            containerPath: arguments[5],
        };
    }
    if (!options.idType) {
        options.idType = 'GlobalUniqueId';
    }
    return request({
        url: (0,ActionURL.buildURL)('specimen-api', 'removeVialsFromRequest', options.containerPath),
        method: 'POST',
        jsonData: {
            idType: options.idType,
            requestId: options.requestId,
            vialIds: options.vialIdArray,
        },
        success: (0,Utils.getCallbackWrapper)(onSpecimenSuccess(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)(rebindFailure((0,Utils.getOnFailure)(options)), options.scope, true),
    });
}
function onSpecimenSuccess(options) {
    const success = (0,Utils.getOnSuccess)(options);
    const { scope } = options;
    if (success) {
        if (scope) {
            return success;
        }
        else {
            return function (data, request, requestOptions) {
                success(data, request, requestOptions);
            };
        }
    }
    return undefined;
}
function remapArguments(options, args) {
    return options && ((0,Utils.isFunction)(options) || args.length > 1);
}
const REBIND = (err, response) => (0,Utils.displayAjaxErrorResponse)(response, err);
function rebindFailure(failure) {
    return failure !== null && failure !== void 0 ? failure : REBIND;
}

;// CONCATENATED MODULE: ./src/labkey/Storage.ts



function createStorageItem(config) {
    return request({
        url: (0,ActionURL.buildURL)('storage', 'create.api', config.containerPath),
        method: 'POST',
        jsonData: {
            type: config.type,
            props: config.props,
        },
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function updateStorageItem(config) {
    return request({
        url: (0,ActionURL.buildURL)('storage', 'update.api', config.containerPath),
        method: 'POST',
        jsonData: {
            type: config.type,
            props: config.props,
        },
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
function deleteStorageItem(config) {
    return request({
        url: (0,ActionURL.buildURL)('storage', 'delete.api', config.containerPath),
        method: 'POST',
        jsonData: {
            type: config.type,
            props: { rowId: config.rowId },
        },
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(config), config.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(config), config.scope, true),
    });
}
var STORAGE_TYPES;
(function (STORAGE_TYPES) {
    STORAGE_TYPES["Canister"] = "Canister";
    STORAGE_TYPES["Freezer"] = "Freezer";
    STORAGE_TYPES["PhysicalLocation"] = "Physical Location";
    STORAGE_TYPES["PrimaryStorage"] = "Primary Storage";
    STORAGE_TYPES["Rack"] = "Rack";
    STORAGE_TYPES["Shelf"] = "Shelf";
    STORAGE_TYPES["StorageUnitType"] = "Storage Unit Type";
    STORAGE_TYPES["TerminalStorageLocation"] = "Terminal Storage Location";
})(STORAGE_TYPES || (STORAGE_TYPES = {}));

;// CONCATENATED MODULE: ./src/labkey/Visualization.ts



;// CONCATENATED MODULE: ./src/labkey/dom/Assay.ts



function importRun(options) {
    if (!FormData) {
        throw new Error('modern browser required');
    }
    if (!options.assayId) {
        throw new Error('assayId required');
    }
    const files = [];
    if (options.files) {
        for (let i = 0; i < options.files.length; i++) {
            const f = options.files[i];
            if (f instanceof File) {
                files.push(f);
            }
            else if (f.tagName == 'INPUT') {
                for (let j = 0; j < f.files.length; j++) {
                    files.push(f.files[j]);
                }
            }
        }
    }
    if (files.length === 0 && !options.runFilePath && !options.dataRows) {
        throw new Error('At least one of "file", "runFilePath", or "dataRows" is required');
    }
    if ((files.length > 0 ? 1 : 0) + (options.runFilePath ? 1 : 0) + (options.dataRows ? 1 : 0) > 1) {
        throw new Error('Only one of "file", "runFilePath", or "dataRows" is allowed');
    }
    const formData = new FormData();
    formData.append('assayId', options.assayId);
    if (options.name) {
        formData.append('name', options.name);
    }
    if (options.comment) {
        formData.append('comment', options.comment);
    }
    if (options.batchId) {
        formData.append('batchId', options.batchId);
    }
    if (options.reRunId) {
        formData.append('reRunId', options.reRunId);
    }
    if (options.saveDataAsFile !== undefined) {
        formData.append('saveDataAsFile', options.saveDataAsFile ? 'true' : 'false');
    }
    if (options.jobDescription) {
        formData.append('jobDescription', options.jobDescription);
    }
    if (options.jobNotificationProvider) {
        formData.append('jobNotificationProvider', options.jobNotificationProvider);
    }
    if (options.forceAsync !== undefined) {
        formData.append('forceAsync', options.forceAsync ? 'true' : 'false');
    }
    if (options.allowCrossRunFileInputs !== undefined) {
        formData.append('allowCrossRunFileInputs', options.allowCrossRunFileInputs ? 'true' : 'false');
    }
    if (options.workflowTask !== undefined) {
        formData.append('workflowTask', options.workflowTask.toString(10));
    }
    if (options.allowLookupByAlternateKey !== undefined) {
        formData.append('allowLookupByAlternateKey', options.allowLookupByAlternateKey ? 'true' : 'false');
    }
    if (options.auditUserComment !== undefined) {
        formData.append('auditUserComment', options.auditUserComment);
    }
    if (options.properties) {
        for (const [key, value] of Object.entries(options.properties)) {
            if ((0,Utils.isObject)(value)) {
                formData.append(`properties['${key}']`, JSON.stringify(value));
            }
            else {
                formData.append(`properties['${key}']`, options.properties[key]);
            }
        }
    }
    if (options.batchProperties) {
        for (const [key, value] of Object.entries(options.batchProperties)) {
            if ((0,Utils.isObject)(value)) {
                formData.append(`batchProperties['${key}']`, JSON.stringify(value));
            }
            else {
                formData.append(`batchProperties['${key}']`, options.batchProperties[key]);
            }
        }
    }
    if (options.dataRows) {
        formData.append('dataRows', JSON.stringify(options.dataRows));
    }
    if (options.runFilePath) {
        formData.append('runFilePath', options.runFilePath);
    }
    if (files && files.length > 0) {
        formData.append('file', files[0]);
        for (let i = 0; i < files.length; i++) {
            formData.append('file' + i, files[i]);
        }
    }
    if (options.resultsFiles && options.resultsFiles.length > 0) {
        for (let i = 0; i < options.resultsFiles.length; i++) {
            formData.append('resultsFile', options.resultsFiles[i]);
        }
    }
    if (options.plateMetadata) {
        formData.append('plateMetadata', JSON.stringify(options.plateMetadata));
    }
    return request({
        url: (0,ActionURL.buildURL)('assay', 'importRun.api', options.containerPath),
        method: 'POST',
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
        form: formData,
    });
}

;// CONCATENATED MODULE: ./src/labkey/dom/constants.ts
if (typeof jQuery !== 'undefined') {
    LABKEY.$ = jQuery;
}
else {
    LABKEY.$ = () => {
        throw new Error('jQuery not available. When using the DOM version of the LabKey API jQuery is expected to be available.');
    };
}
function loadDOMContext() {
    return LABKEY;
}

;// CONCATENATED MODULE: ./src/labkey/dom/Utils.ts




const { $, CSRF: Utils_CSRF } = loadDOMContext();
var DelimiterType;
(function (DelimiterType) {
    DelimiterType["COLON"] = "COLON";
    DelimiterType["COMMA"] = "COMMA";
    DelimiterType["SEMICOLON"] = "SEMICOLON";
    DelimiterType["TAB"] = "TAB";
})(DelimiterType || (DelimiterType = {}));
var QuoteCharType;
(function (QuoteCharType) {
    QuoteCharType["DOUBLE"] = "DOUBLE";
    QuoteCharType["NONE"] = "NONE";
    QuoteCharType["SINGLE"] = "SINGLE";
})(QuoteCharType || (QuoteCharType = {}));
function submitForm(url, formData, formProps) {
    if (!formData) {
        formData = {};
    }
    if (!formData[constants/* CSRF_HEADER */.ZA]) {
        formData[constants/* CSRF_HEADER */.ZA] = Utils_CSRF;
    }
    const formElement = document.createElement('form');
    formElement.action = url;
    formElement.id = (0,Utils.generateUUID)();
    formElement.method = 'POST';
    if (formProps) {
        Object.keys(formProps).forEach(prop => {
            formElement[prop] = formProps[prop];
        });
    }
    Object.keys(formData).forEach(name => {
        const value = formData[name];
        if (value === undefined) {
            return;
        }
        const inputElement = document.createElement('input');
        inputElement.type = 'hidden';
        inputElement.name = name;
        inputElement.value = value;
        formElement.appendChild(inputElement);
    });
    document.body.appendChild(formElement);
    formElement.submit();
}
function Utils_alert(title, msg) {
    if (typeof Ext4 !== 'undefined') {
        Ext4.Msg.alert(title ? Ext4.htmlEncode(title) : '', msg ? Ext4.htmlEncode(msg) : '');
    }
    else if (typeof Ext !== 'undefined') {
        Ext.Msg.alert(title ? Ext.util.Format.htmlEncode(title) : '', msg ? Ext.util.Format.htmlEncode(msg) : '');
    }
    else if (typeof window !== 'undefined') {
        window.alert((0,Utils.encodeHtml)(title + ' : ' + msg));
    }
}
function displayAjaxErrorResponse(response, exceptionObj, showExceptionClass, msgPrefix) {
    if (response.status === 0) {
        return;
    }
    Utils_alert('Error', getMsgFromError(response, exceptionObj, {
        msgPrefix,
        showExceptionClass,
    }));
}
function getMsgFromError(response, exceptionObj, config) {
    config = config || {};
    let error;
    const prefix = config.msgPrefix || 'An error occurred trying to load:\n';
    if (response && response.responseText && response.getResponseHeader('Content-Type')) {
        const contentType = response.getResponseHeader('Content-Type');
        if (contentType.indexOf('application/json') >= 0) {
            const json = (0,Utils.decode)(response.responseText);
            if (json && json.exception) {
                error = prefix + json.exception;
                if (config.showExceptionClass) {
                    error += '\n(' + (json.exceptionClass ? json.exceptionClass : 'Exception class unknown') + ')';
                }
            }
        }
        else if (contentType.indexOf('text/html') >= 0 && $) {
            const html = $(response.responseText);
            const el = html.find('.exception-message');
            if (el && el.length === 1) {
                error = prefix + el.text().trim();
            }
        }
    }
    if (!error) {
        error = prefix + 'Status: ' + response.statusText + ' (' + response.status + ')';
    }
    if (exceptionObj && exceptionObj.message) {
        error += '\n' + exceptionObj.name + ': ' + exceptionObj.message;
    }
    return error;
}
function postToAction(href, formData, formProps) {
    submitForm(href, formData, formProps);
}
function confirmAndPost(message, href, formData, formProps) {
    if (confirm(message)) {
        submitForm(href, formData, formProps);
        return true;
    }
    return false;
}
function setWebpartTitle(title, webPartId) {
    $('table#webpart_' + webPartId + ' span[class=labkey-wp-title-text]').html((0,Utils.encodeHtml)(title));
}
function signalWebDriverTest(signalName, signalResult) {
    const signalContainerId = 'testSignals';
    const signalContainerSelector = '#' + signalContainerId;
    let signalContainer = $(signalContainerSelector);
    const formHTML = '<div id="' + signalContainerId + '"/>';
    if (!signalContainer.length) {
        $('body').append(formHTML);
        signalContainer = $(signalContainerSelector);
        signalContainer.hide();
    }
    signalContainer.find('div[name="' + signalName + '"]').remove();
    signalContainer.append('<div name="' + signalName + '" id="' + (0,Utils.id)() + '"/>');
    if (signalResult) {
        signalContainer.find('div[name="' + signalName + '"]').attr('value', signalResult);
    }
}
const convertToExcel = (workbook) => {
    const formData = { json: JSON.stringify(workbook) };
    submitForm((0,ActionURL.buildURL)('experiment', 'convertArraysToExcel'), formData);
};
const convertToTable = (config) => {
    const formData = { json: JSON.stringify(config) };
    submitForm((0,ActionURL.buildURL)('experiment', 'convertArraysToTable'), formData);
};

;// CONCATENATED MODULE: ./src/labkey/dom/Query.ts





function exportSql(options) {
    postToAction((0,ActionURL.buildURL)('query', 'exportSql', options.containerPath), {
        containerFilter: options.containerFilter,
        format: options.format,
        schemaName: options.schemaName,
        sql: (0,Utils.wafEncode)(options.sql),
    });
}
function exportTables(options) {
    const formData = {};
    if (options.headerType) {
        formData.headerType = options.headerType;
    }
    const schemas = (0,Utils.merge)({}, options.schemas);
    for (const schemaName in schemas) {
        if (!schemas.hasOwnProperty(schemaName)) {
            continue;
        }
        const queryList = schemas[schemaName];
        for (let i = 0; i < queryList.length; i++) {
            const querySettings = queryList[i];
            const o = (0,Utils.merge)({}, querySettings);
            delete o.filter;
            delete o.filterArray;
            delete o.sort;
            o.filters = appendFilterParams(null, querySettings.filters || querySettings.filterArray);
            if (querySettings.sort) {
                o.filters['query.sort'] = querySettings.sort;
            }
            queryList[i] = o;
        }
    }
    formData.schemas = JSON.stringify(schemas);
    postToAction((0,ActionURL.buildURL)('query', 'exportTables.view'), formData);
}
function importData(options) {
    if (!FormData) {
        throw new Error('modern browser required');
    }
    const form = new FormData();
    form.append('schemaName', options.schemaName);
    form.append('queryName', options.queryName);
    if (options.text) {
        form.append('text', options.text);
    }
    if (options.path) {
        form.append('path', options.path);
    }
    if (options.format) {
        form.append('format', options.format);
    }
    if (options.module) {
        form.append('module', options.module);
    }
    if (options.moduleResource) {
        form.append('moduleResource', options.moduleResource);
    }
    if (options.importIdentity) {
        form.append('importIdentity', options.importIdentity);
    }
    if (options.importLookupByAlternateKey !== undefined) {
        form.append('importLookupByAlternateKey', options.importLookupByAlternateKey.toString());
    }
    if (options.useAsync !== undefined) {
        form.append('useAsync', options.useAsync.toString());
    }
    if (options.saveToPipeline !== undefined) {
        form.append('saveToPipeline', options.saveToPipeline.toString());
    }
    if (options.insertOption !== undefined) {
        form.append('insertOption', options.insertOption);
    }
    if (options.auditUserComment !== undefined) {
        form.append('auditUserComment', options.auditUserComment);
    }
    if (options.file) {
        if (options.file instanceof File) {
            form.append('file', options.file);
        }
        else if (options.file.tagName == 'INPUT' && options.file.files.length > 0) {
            form.append('file', options.file.files[0]);
        }
    }
    return request({
        url: options.importUrl || (0,ActionURL.buildURL)('query', 'import.api', options.containerPath),
        method: 'POST',
        form,
        success: (0,Utils.getCallbackWrapper)((0,Utils.getOnSuccess)(options), options.scope),
        failure: (0,Utils.getCallbackWrapper)((0,Utils.getOnFailure)(options), options.scope, true),
        timeout: options.timeout,
    });
}

;// CONCATENATED MODULE: ./src/index.ts






























/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map